/**
 * AUTO-GENERATED by scripts/api-codegen/gen-entities.mjs — do not edit.
 * Regenerate with `npm run generate-api`.
 *
 * One named export per entity base path, mapping each `useEntity` slot to the SDK
 * function that serves it. Entity configs import their own and hand it to
 * `defineEntity`, which is what lets `useEntity` call a named operation instead of
 * concatenating a URL.
 *
 * **Named exports, imported individually — deliberately.** A single lookup table keyed
 * by base path would make all 542 operations reachable from every page that
 * imports `useEntity`, and the bundler could no longer drop the rest. Today the SDK
 * chunk is a few kilobytes because only what is reached survives.
 *
 * Imported from ./index rather than ./gen/sdk.gen so the client's interceptors — XSRF,
 * error notifications, Sentry — are installed before any of these can be called.
 */
import type { EntityOperations } from "./entity";
import {
  appMessagesCreateEntity,
  appMessagesDeleteEntity,
  appMessagesGetEntity,
  appMessagesGetEntityPage,
  appMessagesNotifyImmediately,
  appMessagesUpdateEntity,
  authorizeAuthorizeApi,
  authorizeAuthorizeApiV2,
  authorizeAuthorizeDevice,
  authorizeAuthorizeDeviceFromApiV2,
  authorizeAuthorizeDeviceV2,
  authorizeAuthorizeRefreshTokenV2,
  authorizeAuthorizeService,
  authorizeAuthorizeServiceDeviceV2,
  authorizeCheckContractV2,
  authorizeFinalizeTotpV2,
  authorizeLinkAppleCredentialsV2,
  authorizeLinkCredentialsV2,
  authorizeLinkGoogleCredentialsV2,
  authorizeLoginAppleV2,
  authorizeLoginCookie,
  authorizeLoginCookieV2,
  authorizeLoginCookieVerify,
  authorizeLoginCookieVerifyV2,
  authorizeLoginGoogleV2,
  authorizeLogout,
  authorizeLogoutPost,
  authorizeLogoutPostV2,
  authorizeLogoutV2,
  authorizeReRegisterUserV2,
  authorizeRefreshToken,
  authorizeRegisterDeviceV2,
  authorizeRegisterServiceRunnerV2,
  authorizeSetupTotpV2,
  authorizeUnlinkCredentialsV2,
  authorizeVerifyLoginWithTotpBackupCodeV2,
  authorizeVerifyLoginWithTotpV2,
  batteryTypesListContainerLockTypes,
  billingExportBillingItems,
  billingGetBillingItemsData,
  billingGetBillingReport,
  containerAccessGroupsCreateEntity,
  containerAccessGroupsDeleteEntity,
  containerAccessGroupsGetEntity,
  containerAccessGroupsGetEntityPage,
  containerAccessGroupsIsValueUsed,
  containerAccessGroupsListEntities,
  containerAccessGroupsUpdateEntity,
  containerAddressesCreateContainerIslands,
  containerAddressesCreateEntity,
  containerAddressesDeleteEntity,
  containerAddressesGetEntity,
  containerAddressesGetEntityPage,
  containerAddressesIsValueUsed,
  containerAddressesListEntities,
  containerAddressesUpdateContainersGroup,
  containerAddressesUpdateEntity,
  containerConfigurationTemplatesCreateEntityV2,
  containerConfigurationTemplatesDeleteEntityV2,
  containerConfigurationTemplatesGetEntityPageV2,
  containerConfigurationTemplatesGetEntityV2,
  containerConfigurationTemplatesIsValueUsedV2,
  containerConfigurationTemplatesUpdateEntityV2,
  containerEmptyingsCreateAutomaticRecord,
  containerEmptyingsCreateManualRecord,
  containerEmptyingsExportList,
  containerEmptyingsGetEntityPage,
  containerLockTypeAliasesGetCustomerAliases,
  containerLockTypeAliasesGetEntityPage,
  containerLockTypeAliasesUpdateAliases,
  containerLockTypesListContainerLockTypes,
  containerLockTypesListContainerLockTypesWithAliases,
  containerTransactionConflictsExportList,
  containerTransactionConflictsGetEntityPage,
  containerTransactionsExportList,
  containerTransactionsGetEntityPage,
  containerTransactionsReceiveTransactions,
  containerTypeCreateEntity,
  containerTypeDeleteEntity,
  containerTypeGetEntity,
  containerTypeGetEntityPage,
  containerTypeGetList,
  containerTypeUpdateEntity,
  containersActivateEntity,
  containersCreateEntity,
  containersCreateEntityV2,
  containersDeleteEntity,
  containersExportList,
  containersExportListV2,
  containersExportMultipleFillLevelHistory,
  containersGetContainerLog,
  containersGetContainerMap,
  containersGetContainerMapV2,
  containersGetContainerMapV3,
  containersGetEntity,
  containersGetEntityPage,
  containersGetEntityPageV2,
  containersGetInfoEntityPage,
  containersGetInfoEntityPageV2,
  containersListEntities,
  containersReceiveEmptyingDetectionLogs,
  containersReceiveLogs,
  containersReceiveStatus,
  containersReceiveStatusOnlyTelemetry,
  containersReceiveTransactions,
  containersUpdateEntity,
  containersUpdateEntityV2,
  contractsActivateEntity,
  contractsCreateEntity,
  contractsDeleteEntity,
  contractsExportList,
  contractsGetEntity,
  contractsGetEntityPage,
  contractsIsValueUsed,
  contractsListEntities,
  contractsUpdateEntity,
  customerEulasCreateEntity,
  customerEulasGetEntity,
  customerEulasGetEntityPage,
  customerEulasIsValueUsed,
  customerEulasUpdateEntity,
  customersActivateEntity,
  customersActivateEntityV2,
  customersCreateEntity,
  customersCreateEntityV2,
  customersDeleteEntity,
  customersDeleteEntityV2,
  customersExportList,
  customersExportListV2,
  customersGetChangeContainersCustomerTemplate,
  customersGetCustomersFeatures,
  customersGetEntity,
  customersGetEntityPage,
  customersGetEntityPageV2,
  customersGetEntityV2,
  customersGetImportTemplateContainerAddresses,
  customersGetImportTemplateContainers,
  customersGetImportTemplateContractContainers,
  customersGetImportTemplateContracts,
  customersGetImportTemplateFillLevelSensors,
  customersGetImportTemplateLocationTrackersV2,
  customersGetImportTemplateNfcCards,
  customersGetImportTemplateNfcCardsContracts,
  customersGetImportTemplateNfcCardsV2,
  customersGetImportTemplateRegionCodes,
  customersGetImportTemplateServiceTasks,
  customersImportProAlphaNumbersV2,
  customersIsValueUsed,
  customersIsValueUsedV2,
  customersListDepartments,
  customersListDepartmentsV2,
  customersListEntities,
  customersListEntitiesV2,
  customersTestFtpConnection,
  customersUpdateEntity,
  customersUpdateEntityV2,
  customersValidateProAlphaNumbersV2,
  dashboardExportFillLevelHistory,
  dashboardGetContainersData,
  dashboardGetDashboardIssueData,
  dashboardGetMissingTransactionsData,
  dashboardGetTransactionsData,
  dashboardGetTransactionsTotal,
  dataServicesGetCalculatedContainerIslands,
  devicesGetDevicesPage,
  emptyingDetectionLogsGetEmptyingDetectionLogs,
  emptyingDetectionsCreateEntity,
  emptyingDetectionsDeleteEntity,
  emptyingDetectionsExportEntities,
  emptyingDetectionsGetEntity,
  emptyingDetectionsGetEntityPage,
  emptyingDetectionsIsValueUsed,
  emptyingDetectionsListEntities,
  emptyingDetectionsUpdateContainers,
  emptyingDetectionsUpdateEntity,
  endTestGetEndTestPage,
  filesLoadFile,
  fillLevelSensorConfigurationGroupsCreateEntity,
  fillLevelSensorConfigurationGroupsDeleteEntity,
  fillLevelSensorConfigurationGroupsGetEntity,
  fillLevelSensorConfigurationGroupsGetEntityPage,
  fillLevelSensorConfigurationGroupsIsValueUsed,
  fillLevelSensorConfigurationGroupsListEntities,
  fillLevelSensorConfigurationGroupsUpdateContainersGroup,
  fillLevelSensorConfigurationGroupsUpdateEntity,
  fillLevelSensorTypesListFillLevelSensorTypes,
  fillLevelSensorsActivateFillLevelSensor,
  fillLevelSensorsCreateEntity,
  fillLevelSensorsDeleteFillLevelSensor,
  fillLevelSensorsExportList,
  fillLevelSensorsGetContainersPage,
  fillLevelSensorsGetEntity,
  fillLevelSensorsGetEntityPage,
  fillLevelSensorsIsValueUsed,
  fillLevelSensorsListEntities,
  fillLevelSensorsUpdateEntity,
  firmwareActivateEntity,
  firmwareDeleteEntity,
  firmwareGetEntity,
  firmwareGetEntityPage,
  firmwareListEntities,
  firmwareUpdateEntity,
  firmwareUploadFirmware,
  fractionConfigurationGroupsCreateEntity,
  fractionConfigurationGroupsDeleteEntity,
  fractionConfigurationGroupsGetEntity,
  fractionConfigurationGroupsGetEntityPage,
  fractionConfigurationGroupsIsValueUsed,
  fractionConfigurationGroupsListEntities,
  fractionConfigurationGroupsUpdateContainersGroup,
  fractionConfigurationGroupsUpdateEntity,
  fractionsCreateEntityV2,
  fractionsDeleteEntityV2,
  fractionsGetEntityPageV2,
  fractionsGetEntityV2,
  fractionsIsValueUsedV2,
  fractionsListEntitiesV2,
  fractionsUpdateContainersGroupV2,
  fractionsUpdateEntityV2,
  freeAccessGetContainerFreeAccessTokenForHardwareUnitV2,
  geozonesCreateEntity,
  geozonesDeleteEntity,
  geozonesGetEntity,
  geozonesGetEntityPage,
  geozonesIsValueUsed,
  geozonesUpdateContainersGroup,
  geozonesUpdateEntity,
  hardwareCommandsCreateEntity,
  hardwareCommandsGetEntity,
  hardwareCommandsGetEntityPage,
  hardwareUnitConfigurationChecksGetConfigurationSnapshot,
  hardwareUnitLogMessagesGetListOfModules,
  hardwareUnitLogMessagesGetMessagesPage,
  hardwareUnitLogMessagesImportLogMessages,
  hardwareUnitLogMessagesValidateHardwareUnitLogImport,
  hardwareUnitsExport,
  hardwareUnitsExportMultiTelemetryHistory,
  hardwareUnitsGetEndTestResults,
  hardwareUnitsGetEntity,
  hardwareUnitsGetEntityPage,
  hardwareUnitsGetLog,
  hardwareUnitsListHardwareUnits,
  hardwareUnitsListHardwareUnitsForServiceUser,
  hardwareUnitsListPagedHardwareUnits,
  hardwareUnitsUpdateEntity,
  imagesShowImage,
  imagesUploadImage,
  intervalConfigurationGroupsCreateEntity,
  intervalConfigurationGroupsDeleteEntity,
  intervalConfigurationGroupsGetEntity,
  intervalConfigurationGroupsGetEntityPage,
  intervalConfigurationGroupsIsValueUsed,
  intervalConfigurationGroupsListEntities,
  intervalConfigurationGroupsUpdateContainersGroup,
  intervalConfigurationGroupsUpdateEntity,
  issuesCreateIssue,
  issuesExportList,
  issuesGetIssue,
  issuesGetIssuesPage,
  issuesListIssueTypes,
  languagesListLanguages,
  largeListsActivateEntity,
  largeListsCreateEntity,
  largeListsDeleteEntity,
  largeListsGetEntity,
  largeListsGetEntityPage,
  largeListsGetImportTemplateContractContainers,
  largeListsIsValueUsed,
  largeListsListEntities,
  largeListsUpdateContainers,
  largeListsUpdateEntity,
  liftingSystemsCreateEntity,
  liftingSystemsDeleteEntity,
  liftingSystemsGetEntity,
  liftingSystemsGetEntityPage,
  liftingSystemsListEntities,
  liftingSystemsUpdateEntity,
  locationTrackerTypesListLocationTrackerTypes,
  locationTrackersActivateEntity,
  locationTrackersCreateEntity,
  locationTrackersDeleteEntity,
  locationTrackersGetEntity,
  locationTrackersGetEntityPage,
  locationTrackersIsValueUsed,
  locationTrackersListEntities,
  locationTrackersUpdateEntity,
  materialsCreateEntity,
  materialsDeleteEntity,
  materialsGetEntity,
  materialsGetEntityPage,
  materialsIsValueUsed,
  materialsListMaterials,
  materialsUpdateEntity,
  meAddContractV2,
  meGetAllContainersDataV2V2,
  meGetContainerMap,
  meGetContainerMapV2,
  meGetContainers,
  meGetContainersV2,
  meGetFeatures,
  meGetFeaturesV2,
  meGetMessages,
  meGetMessagesV2,
  meGetTransactions,
  meGetTransactionsDailyCountReport,
  meGetTransactionsDailyCountReportV2,
  meGetTransactionsV2,
  meGetUserProfile,
  meGetUserProfileV2,
  meGetUserTransactionFraction,
  meGetUserTransactionFractionV2,
  meGetUserTransactionTotals,
  meGetUserTransactionTotalsByFraction,
  meGetUserTransactionTotalsByFractionDetailed,
  meGetUserTransactionTotalsByFractionDetailedV2,
  meGetUserTransactionTotalsByFractionV2,
  meGetUserTransactionTotalsBySource,
  meGetUserTransactionTotalsBySourceV2,
  meGetUserTransactionTotalsDetailed,
  meGetUserTransactionTotalsDetailedV2,
  meGetUserTransactionTotalsV2,
  meUpdateUserContractV2,
  meUpdateUserDeviceV2,
  mifareDataReadFrameCreateEntity,
  mifareDataReadFrameDeleteEntity,
  mifareDataReadFrameGetEntity,
  mifareDataReadFrameGetEntityPage,
  mifareDataReadFrameIsValueUsed,
  mifareDataReadFrameListEntities,
  mifareDataReadFrameUpdateEntity,
  nfcCardBlacklistsCreateEntity,
  nfcCardBlacklistsDeleteEntity,
  nfcCardBlacklistsGetEntity,
  nfcCardBlacklistsGetEntityPage,
  nfcCardBlacklistsIsValueUsed,
  nfcCardBlacklistsListEntities,
  nfcCardBlacklistsUpdateEntity,
  nfcCardConfigurationGroupsCreateEntity,
  nfcCardConfigurationGroupsDeleteEntity,
  nfcCardConfigurationGroupsGetEntity,
  nfcCardConfigurationGroupsGetEntityPage,
  nfcCardConfigurationGroupsIsValueUsed,
  nfcCardConfigurationGroupsListEligible,
  nfcCardConfigurationGroupsListEntities,
  nfcCardConfigurationGroupsUpdateContainersGroup,
  nfcCardConfigurationGroupsUpdateEntity,
  nfcCardsActivateEntity,
  nfcCardsCreateEntity,
  nfcCardsExportList,
  nfcCardsGenerateBleKeys,
  nfcCardsGetEntity,
  nfcCardsGetEntityPage,
  nfcCardsIsValueUsed,
  nfcCardsListCardAuthenticationTypes,
  nfcCardsListCardReaderTypes,
  nfcCardsListCardTypes,
  nfcCardsListEntities,
  nfcCardsUpdateEntity,
  notificationSettingsCreateNotificationSetting,
  notificationSettingsDeleteNotificationSetting,
  notificationSettingsGetNotificationSetting,
  notificationSettingsUpdateNotificationSetting,
  permissionGroupsCreateEntity,
  permissionGroupsDeleteEntity,
  permissionGroupsGetEffectiveRolesByGroupIds,
  permissionGroupsGetEntity,
  permissionGroupsGetEntityPage,
  permissionGroupsIsValueUsed,
  permissionGroupsListEntities,
  permissionGroupsUpdateEntity,
  productsCreateEntity,
  productsDeleteEntity,
  productsGetByPartNumber,
  productsGetEntity,
  productsGetEntityPage,
  productsIsValueUsed,
  productsListEntities,
  productsUpdateEntity,
  regionCodesConfigurationGroupsCreateEntity,
  regionCodesConfigurationGroupsDeleteEntity,
  regionCodesConfigurationGroupsGetEntity,
  regionCodesConfigurationGroupsGetEntityPage,
  regionCodesConfigurationGroupsIsValueUsed,
  regionCodesConfigurationGroupsListEntities,
  regionCodesConfigurationGroupsUpdateContainersGroup,
  regionCodesConfigurationGroupsUpdateEntity,
  regionCodesCreateEntity,
  regionCodesDeleteEntity,
  regionCodesExportList,
  regionCodesGetEntity,
  regionCodesGetEntityPage,
  regionCodesIsValueUsed,
  regionCodesListEntities,
  regionCodesUpdateEntity,
  reportsCreateTaskListReport,
  reportsDeleteReport,
  reportsExportList,
  reportsGetBatteryLifeReport,
  reportsGetIssueReportsDailyCountReport,
  reportsGetLastCommunicationFlsReport,
  reportsGetLastCommunicationLocationTracker,
  reportsGetLastCommunicationReport,
  reportsGetPagedBatteryLifeReport,
  reportsGetReportConfiguration,
  reportsGetReportsPage,
  reportsGetTransactionsDailyCountReport,
  reportsRunTaskListReport,
  reportsUpdateTaskListReport,
  rolesGetAll,
  serverInfoGetConfig,
  serverInfoGetExportSettings,
  serviceAppEventsCreateEntity,
  serviceAppEventsExportServiceAppEvents,
  serviceAppEventsGetEntity,
  serviceAppEventsGetEntityPage,
  serviceCallsExportServiceCalls,
  serviceCallsGetServiceCallsPage,
  serviceCallsListServiceCalls,
  serviceDashboardGetDashboardData,
  serviceTaskCategoriesCreateEntity,
  serviceTaskCategoriesDeleteEntity,
  serviceTaskCategoriesGetEntity,
  serviceTaskCategoriesGetEntityPage,
  serviceTaskCategoriesIsValueUsed,
  serviceTaskCategoriesListCategories,
  serviceTaskCategoriesUpdateEntity,
  serviceTaskCausesCreateEntity,
  serviceTaskCausesDeleteEntity,
  serviceTaskCausesGetEntity,
  serviceTaskCausesGetEntityPage,
  serviceTaskCausesIsValueUsed,
  serviceTaskCausesListCauses,
  serviceTaskCausesUpdateEntity,
  serviceTaskCreateServiceTask,
  serviceTaskExportList,
  serviceTaskGetServiceTask,
  serviceTaskGetServiceTaskList,
  serviceTaskGetServiceTaskLogsPage,
  serviceTaskGetServiceTaskPage,
  serviceTaskSolutionsCreateEntity,
  serviceTaskSolutionsDeleteEntity,
  serviceTaskSolutionsGetEntity,
  serviceTaskSolutionsGetEntityPage,
  serviceTaskSolutionsIsValueUsed,
  serviceTaskSolutionsListSolutions,
  serviceTaskSolutionsUpdateEntity,
  serviceTaskUpdateServiceTask,
  simCardsGetTerminateTemplate,
  simCardsTerminateSimCards,
  simCardsValidatSimCardsForTermination,
  slocGetSlocCustomerName,
  slocGetSlocEmptyingOptions,
  slocGetSlocGroups,
  slocGetSlocGroupsByApiKey,
  slocGetSlocProfiles,
  slocHasValidSlocApiKey,
  slocReceiveSlocData,
  socialServiceActionsGetEntity,
  socialServiceActionsGetEntityPage,
  socialServiceActionsListCategories,
  socialServiceActionsUpdateEntity,
  socialServiceGetRunnerNotificationSettings,
  socialServiceGetTransactions,
  socialServiceNotificationsNotifyRunners,
  socialServiceRunnersGetEntityPage,
  socialServiceRunnersListUsers,
  socialServiceTaskGetEntityPage,
  socialServiceTaskGetSocialServiceTask,
  socialServiceTaskListOfAssignedSocialServiceTasksToCurrentUser,
  socialServiceTaskSocialServiceTasksMap,
  supersetDashboardsCreateEntity,
  supersetDashboardsDeleteEntity,
  supersetDashboardsGetEntity,
  supersetDashboardsGetEntityPage,
  supersetDashboardsIsValueUsed,
  supersetDashboardsListEntities,
  supersetDashboardsUpdateEntity,
  systemOperationsLogExportList,
  systemOperationsLogGetEntityPage,
  systemOperationsLogGetIssue,
  techniciansGetEntityPage,
  techniciansListUsers,
  truckBodiesCreateEntity,
  truckBodiesDeleteEntity,
  truckBodiesGetEntity,
  truckBodiesGetEntityPage,
  truckBodiesListEntities,
  truckBodiesUpdateEntity,
  truckDepotsCreateEntity,
  truckDepotsDeleteEntity,
  truckDepotsGetEntity,
  truckDepotsGetEntityPage,
  truckDepotsListEntities,
  truckDepotsUpdateContainersGroup,
  truckDepotsUpdateEntity,
  truckTypesCreateEntity,
  truckTypesDeleteEntity,
  truckTypesGetEntity,
  truckTypesGetEntityPage,
  truckTypesListEntities,
  truckTypesUpdateEntity,
  trucksCreateEntity,
  trucksDeleteEntity,
  trucksGetEntity,
  trucksGetEntityPage,
  trucksListEntities,
  trucksUpdateEntity,
  userNotificationSettingsCreateProfileNotificationSetting,
  userNotificationSettingsDeleteNotificationSetting,
  userNotificationSettingsGetProfileNotificationSetting,
  userNotificationSettingsGetUserNotificationSettingsPage,
  userNotificationSettingsUpdateProfileNotificationSetting,
  userWizardCreateUserWizard,
  userWizardDeleteUserWizard,
  userWizardGetUserWizard,
  userWizardGetUserWizardPage,
  userWizardUpdateUserWizard,
  usersActivateUser,
  usersChangeOwnPassword,
  usersCreateEntity,
  usersDeleteEntity,
  usersExportList,
  usersGetEntity,
  usersGetEntityPage,
  usersGetMyFavourites,
  usersGetMyPreferences,
  usersGetProfile,
  usersInitPasswordReset,
  usersIsValueUsed,
  usersListUsers,
  usersResetTotpSettings,
  usersUnregisterOwnDevice,
  usersUpdateEntity,
  usersUpdateProfile,
  usersVerifyPasswordReset,
  wasteCategoriesListContainerLockTypes,
  wasteYardsCreateEntity,
  wasteYardsDeleteEntity,
  wasteYardsGetEntity,
  wasteYardsGetEntityPage,
  wasteYardsListEntities,
  wasteYardsUpdateEntity,
} from "./index";

/** /api/v1/app-messages */
export const appMessagesOps = {
  entity: { endpoint: "app-messages", apiVersion: "v1" },
  page: { id: "appMessagesGetEntityPage", call: appMessagesGetEntityPage },
  create: { id: "appMessagesCreateEntity", call: appMessagesCreateEntity },
  detail: { id: "appMessagesGetEntity", call: appMessagesGetEntity, param: "id" },
  update: { id: "appMessagesUpdateEntity", call: appMessagesUpdateEntity, param: "id" },
  remove: { id: "appMessagesDeleteEntity", call: appMessagesDeleteEntity, param: "id" },
} satisfies EntityOperations;

/** /api/v1/app-messages/notify */
export const appMessagesNotifyOps = {
  entity: { endpoint: "app-messages/notify", apiVersion: "v1" },
  create: { id: "appMessagesNotifyImmediately", call: appMessagesNotifyImmediately },
} satisfies EntityOperations;

/** /api/v1/authorize */
export const authorizeOps = {
  entity: { endpoint: "authorize", apiVersion: "v1" },
  create: { id: "authorizeAuthorizeDevice", call: authorizeAuthorizeDevice },
} satisfies EntityOperations;

/** /api/v1/authorize/api */
export const authorizeApiOps = {
  entity: { endpoint: "authorize/api", apiVersion: "v1" },
  create: { id: "authorizeAuthorizeApi", call: authorizeAuthorizeApi },
} satisfies EntityOperations;

/** /api/v1/authorize/login */
export const authorizeLoginOps = {
  entity: { endpoint: "authorize/login", apiVersion: "v1" },
  page: { id: "authorizeLoginCookieVerify", call: authorizeLoginCookieVerify },
  create: { id: "authorizeLoginCookie", call: authorizeLoginCookie },
} satisfies EntityOperations;

/** /api/v1/authorize/logout */
export const authorizeLogoutOps = {
  entity: { endpoint: "authorize/logout", apiVersion: "v1" },
  page: { id: "authorizeLogout", call: authorizeLogout },
  create: { id: "authorizeLogoutPost", call: authorizeLogoutPost },
} satisfies EntityOperations;

/** /api/v1/authorize/refresh-token */
export const authorizeRefreshTokenOps = {
  entity: { endpoint: "authorize/refresh-token", apiVersion: "v1" },
  create: { id: "authorizeRefreshToken", call: authorizeRefreshToken },
} satisfies EntityOperations;

/** /api/v1/authorize/service-app */
export const authorizeServiceAppOps = {
  entity: { endpoint: "authorize/service-app", apiVersion: "v1" },
  create: { id: "authorizeAuthorizeService", call: authorizeAuthorizeService },
} satisfies EntityOperations;

/** /api/v1/battery-types */
export const batteryTypesOps = {
  entity: { endpoint: "battery-types", apiVersion: "v1" },
  page: { id: "batteryTypesListContainerLockTypes", call: batteryTypesListContainerLockTypes },
} satisfies EntityOperations;

/** /api/v1/billing */
export const billingOps = {
  entity: { endpoint: "billing", apiVersion: "v1" },
  page: { id: "billingGetBillingReport", call: billingGetBillingReport },
} satisfies EntityOperations;

/** /api/v1/billing/items */
export const billingItemsOps = {
  entity: { endpoint: "billing/items", apiVersion: "v1" },
  page: { id: "billingGetBillingItemsData", call: billingGetBillingItemsData },
  export: { id: "billingExportBillingItems", call: billingExportBillingItems, param: "format" },
} satisfies EntityOperations;

/** /api/v1/container-access-groups */
export const containerAccessGroupsOps = {
  entity: { endpoint: "container-access-groups", apiVersion: "v1" },
  page: { id: "containerAccessGroupsGetEntityPage", call: containerAccessGroupsGetEntityPage },
  create: { id: "containerAccessGroupsCreateEntity", call: containerAccessGroupsCreateEntity },
  detail: { id: "containerAccessGroupsGetEntity", call: containerAccessGroupsGetEntity, param: "id" },
  update: { id: "containerAccessGroupsUpdateEntity", call: containerAccessGroupsUpdateEntity, param: "id" },
  remove: { id: "containerAccessGroupsDeleteEntity", call: containerAccessGroupsDeleteEntity, param: "id" },
  list: { id: "containerAccessGroupsListEntities", call: containerAccessGroupsListEntities },
  valueUsed: { id: "containerAccessGroupsIsValueUsed", call: containerAccessGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/container-access-groups/list */
export const containerAccessGroupsListOps = {
  entity: { endpoint: "container-access-groups/list", apiVersion: "v1" },
  page: { id: "containerAccessGroupsListEntities", call: containerAccessGroupsListEntities },
} satisfies EntityOperations;

/** /api/v1/container-access-groups/value-used */
export const containerAccessGroupsValueUsedOps = {
  entity: { endpoint: "container-access-groups/value-used", apiVersion: "v1" },
  create: { id: "containerAccessGroupsIsValueUsed", call: containerAccessGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/container-addresses */
export const containerAddressesOps = {
  entity: { endpoint: "container-addresses", apiVersion: "v1" },
  page: { id: "containerAddressesGetEntityPage", call: containerAddressesGetEntityPage },
  create: { id: "containerAddressesCreateEntity", call: containerAddressesCreateEntity },
  detail: { id: "containerAddressesGetEntity", call: containerAddressesGetEntity, param: "id" },
  update: { id: "containerAddressesUpdateEntity", call: containerAddressesUpdateEntity, param: "id" },
  remove: { id: "containerAddressesDeleteEntity", call: containerAddressesDeleteEntity, param: "id" },
  list: { id: "containerAddressesListEntities", call: containerAddressesListEntities },
  valueUsed: { id: "containerAddressesIsValueUsed", call: containerAddressesIsValueUsed },
  containersPartial: {
    id: "containerAddressesUpdateContainersGroup",
    call: containerAddressesUpdateContainersGroup,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/container-addresses/islands */
export const containerAddressesIslandsOps = {
  entity: { endpoint: "container-addresses/islands", apiVersion: "v1" },
  create: { id: "containerAddressesCreateContainerIslands", call: containerAddressesCreateContainerIslands },
} satisfies EntityOperations;

/** /api/v1/container-addresses/list */
export const containerAddressesListOps = {
  entity: { endpoint: "container-addresses/list", apiVersion: "v1" },
  page: { id: "containerAddressesListEntities", call: containerAddressesListEntities },
} satisfies EntityOperations;

/** /api/v1/container-addresses/value-used */
export const containerAddressesValueUsedOps = {
  entity: { endpoint: "container-addresses/value-used", apiVersion: "v1" },
  create: { id: "containerAddressesIsValueUsed", call: containerAddressesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/container-emptyings */
export const containerEmptyingsOps = {
  entity: { endpoint: "container-emptyings", apiVersion: "v1" },
  page: { id: "containerEmptyingsGetEntityPage", call: containerEmptyingsGetEntityPage },
  create: { id: "containerEmptyingsCreateManualRecord", call: containerEmptyingsCreateManualRecord },
  export: { id: "containerEmptyingsExportList", call: containerEmptyingsExportList, param: "format" },
} satisfies EntityOperations;

/** /api/v1/container-emptyings/auto */
export const containerEmptyingsAutoOps = {
  entity: { endpoint: "container-emptyings/auto", apiVersion: "v1" },
  create: { id: "containerEmptyingsCreateAutomaticRecord", call: containerEmptyingsCreateAutomaticRecord },
} satisfies EntityOperations;

/** /api/v1/container-lock-type-aliases */
export const containerLockTypeAliasesOps = {
  entity: { endpoint: "container-lock-type-aliases", apiVersion: "v1" },
  page: { id: "containerLockTypeAliasesGetEntityPage", call: containerLockTypeAliasesGetEntityPage },
  detail: {
    id: "containerLockTypeAliasesGetCustomerAliases",
    call: containerLockTypeAliasesGetCustomerAliases,
    param: "customerId",
  },
  update: {
    id: "containerLockTypeAliasesUpdateAliases",
    call: containerLockTypeAliasesUpdateAliases,
    param: "customerId",
  },
} satisfies EntityOperations;

/** /api/v1/container-lock-types */
export const containerLockTypesOps = {
  entity: { endpoint: "container-lock-types", apiVersion: "v1" },
  page: { id: "containerLockTypesListContainerLockTypes", call: containerLockTypesListContainerLockTypes },
  detail: {
    id: "containerLockTypesListContainerLockTypesWithAliases",
    call: containerLockTypesListContainerLockTypesWithAliases,
    param: "customerId",
  },
} satisfies EntityOperations;

/** /api/v1/container-transaction-conflicts */
export const containerTransactionConflictsOps = {
  entity: { endpoint: "container-transaction-conflicts", apiVersion: "v1" },
  page: { id: "containerTransactionConflictsGetEntityPage", call: containerTransactionConflictsGetEntityPage },
  export: {
    id: "containerTransactionConflictsExportList",
    call: containerTransactionConflictsExportList,
    param: "format",
  },
} satisfies EntityOperations;

/** /api/v1/container-transactions */
export const containerTransactionsOps = {
  entity: { endpoint: "container-transactions", apiVersion: "v1" },
  page: { id: "containerTransactionsGetEntityPage", call: containerTransactionsGetEntityPage },
  create: { id: "containerTransactionsReceiveTransactions", call: containerTransactionsReceiveTransactions },
  export: { id: "containerTransactionsExportList", call: containerTransactionsExportList, param: "format" },
} satisfies EntityOperations;

/** /api/v1/container-type */
export const containerTypeOps = {
  entity: { endpoint: "container-type", apiVersion: "v1" },
  page: { id: "containerTypeGetEntityPage", call: containerTypeGetEntityPage },
  create: { id: "containerTypeCreateEntity", call: containerTypeCreateEntity },
  detail: { id: "containerTypeGetEntity", call: containerTypeGetEntity, param: "id" },
  update: { id: "containerTypeUpdateEntity", call: containerTypeUpdateEntity, param: "id" },
  remove: { id: "containerTypeDeleteEntity", call: containerTypeDeleteEntity, param: "id" },
  list: { id: "containerTypeGetList", call: containerTypeGetList },
} satisfies EntityOperations;

/** /api/v1/container-type/list */
export const containerTypeListOps = {
  entity: { endpoint: "container-type/list", apiVersion: "v1" },
  page: { id: "containerTypeGetList", call: containerTypeGetList },
} satisfies EntityOperations;

/** /api/v1/containers */
export const containersOps = {
  entity: { endpoint: "containers", apiVersion: "v1" },
  page: { id: "containersGetEntityPage", call: containersGetEntityPage },
  create: { id: "containersCreateEntity", call: containersCreateEntity },
  detail: { id: "containersGetEntity", call: containersGetEntity, param: "id" },
  update: { id: "containersUpdateEntity", call: containersUpdateEntity, param: "id" },
  remove: { id: "containersDeleteEntity", call: containersDeleteEntity, param: "id" },
  activate: { id: "containersActivateEntity", call: containersActivateEntity, param: "id" },
  list: { id: "containersListEntities", call: containersListEntities },
  export: { id: "containersExportList", call: containersExportList, param: "format" },
  log: { id: "containersGetContainerLog", call: containersGetContainerLog, param: "containerId" },
} satisfies EntityOperations;

/** /api/v1/containers/emptying-detection-logs */
export const containersEmptyingDetectionLogsOps = {
  entity: { endpoint: "containers/emptying-detection-logs", apiVersion: "v1" },
  create: { id: "containersReceiveEmptyingDetectionLogs", call: containersReceiveEmptyingDetectionLogs },
} satisfies EntityOperations;

/** /api/v1/containers/fill-levels */
export const containersFillLevelsOps = {
  entity: { endpoint: "containers/fill-levels", apiVersion: "v1" },
  export: {
    id: "containersExportMultipleFillLevelHistory",
    call: containersExportMultipleFillLevelHistory,
    param: "format",
  },
} satisfies EntityOperations;

/** /api/v1/containers/list */
export const containersListOps = {
  entity: { endpoint: "containers/list", apiVersion: "v1" },
  page: { id: "containersListEntities", call: containersListEntities },
} satisfies EntityOperations;

/** /api/v1/containers/list-paged */
export const containersListPagedOps = {
  entity: { endpoint: "containers/list-paged", apiVersion: "v1" },
  page: { id: "containersGetInfoEntityPage", call: containersGetInfoEntityPage },
} satisfies EntityOperations;

/** /api/v1/containers/logs */
export const containersLogsOps = {
  entity: { endpoint: "containers/logs", apiVersion: "v1" },
  create: { id: "containersReceiveLogs", call: containersReceiveLogs },
} satisfies EntityOperations;

/** /api/v1/containers/map */
export const containersMapOps = {
  entity: { endpoint: "containers/map", apiVersion: "v1" },
  page: { id: "containersGetContainerMap", call: containersGetContainerMap },
} satisfies EntityOperations;

/** /api/v1/containers/short-status */
export const containersShortStatusOps = {
  entity: { endpoint: "containers/short-status", apiVersion: "v1" },
  create: { id: "containersReceiveStatusOnlyTelemetry", call: containersReceiveStatusOnlyTelemetry },
} satisfies EntityOperations;

/** /api/v1/containers/status */
export const containersStatusOps = {
  entity: { endpoint: "containers/status", apiVersion: "v1" },
  create: { id: "containersReceiveStatus", call: containersReceiveStatus },
} satisfies EntityOperations;

/** /api/v1/containers/transactions */
export const containersTransactionsOps = {
  entity: { endpoint: "containers/transactions", apiVersion: "v1" },
  create: { id: "containersReceiveTransactions", call: containersReceiveTransactions },
} satisfies EntityOperations;

/** /api/v1/contracts */
export const contractsOps = {
  entity: { endpoint: "contracts", apiVersion: "v1" },
  page: { id: "contractsGetEntityPage", call: contractsGetEntityPage },
  create: { id: "contractsCreateEntity", call: contractsCreateEntity },
  detail: { id: "contractsGetEntity", call: contractsGetEntity, param: "id" },
  update: { id: "contractsUpdateEntity", call: contractsUpdateEntity, param: "id" },
  remove: { id: "contractsDeleteEntity", call: contractsDeleteEntity, param: "id" },
  activate: { id: "contractsActivateEntity", call: contractsActivateEntity, param: "id" },
  list: { id: "contractsListEntities", call: contractsListEntities },
  export: { id: "contractsExportList", call: contractsExportList, param: "format" },
  valueUsed: { id: "contractsIsValueUsed", call: contractsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/contracts/list */
export const contractsListOps = {
  entity: { endpoint: "contracts/list", apiVersion: "v1" },
  page: { id: "contractsListEntities", call: contractsListEntities },
} satisfies EntityOperations;

/** /api/v1/contracts/value-used */
export const contractsValueUsedOps = {
  entity: { endpoint: "contracts/value-used", apiVersion: "v1" },
  create: { id: "contractsIsValueUsed", call: contractsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/customer-eulas */
export const customerEulasOps = {
  entity: { endpoint: "customer-eulas", apiVersion: "v1" },
  page: { id: "customerEulasGetEntityPage", call: customerEulasGetEntityPage },
  create: { id: "customerEulasCreateEntity", call: customerEulasCreateEntity },
  detail: { id: "customerEulasGetEntity", call: customerEulasGetEntity, param: "id" },
  update: { id: "customerEulasUpdateEntity", call: customerEulasUpdateEntity, param: "id" },
  valueUsed: { id: "customerEulasIsValueUsed", call: customerEulasIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/customer-eulas/value-used */
export const customerEulasValueUsedOps = {
  entity: { endpoint: "customer-eulas/value-used", apiVersion: "v1" },
  create: { id: "customerEulasIsValueUsed", call: customerEulasIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/customers */
export const customersOps = {
  entity: { endpoint: "customers", apiVersion: "v1" },
  page: { id: "customersGetEntityPage", call: customersGetEntityPage },
  create: { id: "customersCreateEntity", call: customersCreateEntity },
  detail: { id: "customersGetEntity", call: customersGetEntity, param: "id" },
  update: { id: "customersUpdateEntity", call: customersUpdateEntity, param: "id" },
  remove: { id: "customersDeleteEntity", call: customersDeleteEntity, param: "id" },
  activate: { id: "customersActivateEntity", call: customersActivateEntity, param: "id" },
  list: { id: "customersListEntities", call: customersListEntities },
  export: { id: "customersExportList", call: customersExportList, param: "format" },
  valueUsed: { id: "customersIsValueUsed", call: customersIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/customers/departments */
export const customersDepartmentsOps = {
  entity: { endpoint: "customers/departments", apiVersion: "v1" },
  list: { id: "customersListDepartments", call: customersListDepartments },
} satisfies EntityOperations;

/** /api/v1/customers/departments/list */
export const customersDepartmentsListOps = {
  entity: { endpoint: "customers/departments/list", apiVersion: "v1" },
  page: { id: "customersListDepartments", call: customersListDepartments },
} satisfies EntityOperations;

/** /api/v1/customers/features */
export const customersFeaturesOps = {
  entity: { endpoint: "customers/features", apiVersion: "v1" },
  page: { id: "customersGetCustomersFeatures", call: customersGetCustomersFeatures },
} satisfies EntityOperations;

/** /api/v1/customers/ftp/test */
export const customersFtpTestOps = {
  entity: { endpoint: "customers/ftp/test", apiVersion: "v1" },
  create: { id: "customersTestFtpConnection", call: customersTestFtpConnection },
} satisfies EntityOperations;

/** /api/v1/customers/list */
export const customersListOps = {
  entity: { endpoint: "customers/list", apiVersion: "v1" },
  page: { id: "customersListEntities", call: customersListEntities },
} satisfies EntityOperations;

/** /api/v1/customers/template/container-addresses.csv */
export const customersTemplateContainerAddressesCsvOps = {
  entity: { endpoint: "customers/template/container-addresses.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateContainerAddresses", call: customersGetImportTemplateContainerAddresses },
} satisfies EntityOperations;

/** /api/v1/customers/template/containers-customer.csv */
export const customersTemplateContainersCustomerCsvOps = {
  entity: { endpoint: "customers/template/containers-customer.csv", apiVersion: "v1" },
  page: { id: "customersGetChangeContainersCustomerTemplate", call: customersGetChangeContainersCustomerTemplate },
} satisfies EntityOperations;

/** /api/v1/customers/template/containers.csv */
export const customersTemplateContainersCsvOps = {
  entity: { endpoint: "customers/template/containers.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateContainers", call: customersGetImportTemplateContainers },
} satisfies EntityOperations;

/** /api/v1/customers/template/contract-containers.csv */
export const customersTemplateContractContainersCsvOps = {
  entity: { endpoint: "customers/template/contract-containers.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateContractContainers", call: customersGetImportTemplateContractContainers },
} satisfies EntityOperations;

/** /api/v1/customers/template/contracts.csv */
export const customersTemplateContractsCsvOps = {
  entity: { endpoint: "customers/template/contracts.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateContracts", call: customersGetImportTemplateContracts },
} satisfies EntityOperations;

/** /api/v1/customers/template/fill-level-sensors.csv */
export const customersTemplateFillLevelSensorsCsvOps = {
  entity: { endpoint: "customers/template/fill-level-sensors.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateFillLevelSensors", call: customersGetImportTemplateFillLevelSensors },
} satisfies EntityOperations;

/** /api/v1/customers/template/nfc-cards-contracts.csv */
export const customersTemplateNfcCardsContractsCsvOps = {
  entity: { endpoint: "customers/template/nfc-cards-contracts.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateNfcCardsContracts", call: customersGetImportTemplateNfcCardsContracts },
} satisfies EntityOperations;

/** /api/v1/customers/template/nfc-cards.csv */
export const customersTemplateNfcCardsCsvOps = {
  entity: { endpoint: "customers/template/nfc-cards.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateNfcCards", call: customersGetImportTemplateNfcCards },
} satisfies EntityOperations;

/** /api/v1/customers/template/region-codes.csv */
export const customersTemplateRegionCodesCsvOps = {
  entity: { endpoint: "customers/template/region-codes.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateRegionCodes", call: customersGetImportTemplateRegionCodes },
} satisfies EntityOperations;

/** /api/v1/customers/template/service-tasks.csv */
export const customersTemplateServiceTasksCsvOps = {
  entity: { endpoint: "customers/template/service-tasks.csv", apiVersion: "v1" },
  page: { id: "customersGetImportTemplateServiceTasks", call: customersGetImportTemplateServiceTasks },
} satisfies EntityOperations;

/** /api/v1/customers/value-used */
export const customersValueUsedOps = {
  entity: { endpoint: "customers/value-used", apiVersion: "v1" },
  create: { id: "customersIsValueUsed", call: customersIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/dashboard/containers */
export const dashboardContainersOps = {
  entity: { endpoint: "dashboard/containers", apiVersion: "v1" },
  page: { id: "dashboardGetContainersData", call: dashboardGetContainersData },
} satisfies EntityOperations;

/** /api/v1/dashboard/issue-reports */
export const dashboardIssueReportsOps = {
  entity: { endpoint: "dashboard/issue-reports", apiVersion: "v1" },
  page: { id: "dashboardGetDashboardIssueData", call: dashboardGetDashboardIssueData },
} satisfies EntityOperations;

/** /api/v1/dashboard/missing-transactions */
export const dashboardMissingTransactionsOps = {
  entity: { endpoint: "dashboard/missing-transactions", apiVersion: "v1" },
  page: { id: "dashboardGetMissingTransactionsData", call: dashboardGetMissingTransactionsData },
  export: { id: "dashboardExportFillLevelHistory", call: dashboardExportFillLevelHistory, param: "format" },
} satisfies EntityOperations;

/** /api/v1/dashboard/transactions */
export const dashboardTransactionsOps = {
  entity: { endpoint: "dashboard/transactions", apiVersion: "v1" },
  page: { id: "dashboardGetTransactionsData", call: dashboardGetTransactionsData },
} satisfies EntityOperations;

/** /api/v1/dashboard/transactions-total */
export const dashboardTransactionsTotalOps = {
  entity: { endpoint: "dashboard/transactions-total", apiVersion: "v1" },
  page: { id: "dashboardGetTransactionsTotal", call: dashboardGetTransactionsTotal },
} satisfies EntityOperations;

/** /api/v1/data-services/container-islands/calculate */
export const dataServicesContainerIslandsCalculateOps = {
  entity: { endpoint: "data-services/container-islands/calculate", apiVersion: "v1" },
  create: { id: "dataServicesGetCalculatedContainerIslands", call: dataServicesGetCalculatedContainerIslands },
} satisfies EntityOperations;

/** /api/v1/devices */
export const devicesOps = {
  entity: { endpoint: "devices", apiVersion: "v1" },
  page: { id: "devicesGetDevicesPage", call: devicesGetDevicesPage },
} satisfies EntityOperations;

/** /api/v1/emptying-detection-logs */
export const emptyingDetectionLogsOps = {
  entity: { endpoint: "emptying-detection-logs", apiVersion: "v1" },
  page: { id: "emptyingDetectionLogsGetEmptyingDetectionLogs", call: emptyingDetectionLogsGetEmptyingDetectionLogs },
} satisfies EntityOperations;

/** /api/v1/emptying-detections */
export const emptyingDetectionsOps = {
  entity: { endpoint: "emptying-detections", apiVersion: "v1" },
  page: { id: "emptyingDetectionsGetEntityPage", call: emptyingDetectionsGetEntityPage },
  create: { id: "emptyingDetectionsCreateEntity", call: emptyingDetectionsCreateEntity },
  detail: { id: "emptyingDetectionsGetEntity", call: emptyingDetectionsGetEntity, param: "id" },
  update: { id: "emptyingDetectionsUpdateEntity", call: emptyingDetectionsUpdateEntity, param: "id" },
  remove: { id: "emptyingDetectionsDeleteEntity", call: emptyingDetectionsDeleteEntity, param: "id" },
  list: { id: "emptyingDetectionsListEntities", call: emptyingDetectionsListEntities },
  export: { id: "emptyingDetectionsExportEntities", call: emptyingDetectionsExportEntities, param: "format" },
  valueUsed: { id: "emptyingDetectionsIsValueUsed", call: emptyingDetectionsIsValueUsed },
  containersPartial: {
    id: "emptyingDetectionsUpdateContainers",
    call: emptyingDetectionsUpdateContainers,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/emptying-detections/list */
export const emptyingDetectionsListOps = {
  entity: { endpoint: "emptying-detections/list", apiVersion: "v1" },
  page: { id: "emptyingDetectionsListEntities", call: emptyingDetectionsListEntities },
} satisfies EntityOperations;

/** /api/v1/emptying-detections/value-used */
export const emptyingDetectionsValueUsedOps = {
  entity: { endpoint: "emptying-detections/value-used", apiVersion: "v1" },
  create: { id: "emptyingDetectionsIsValueUsed", call: emptyingDetectionsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/end-test */
export const endTestOps = {
  entity: { endpoint: "end-test", apiVersion: "v1" },
  page: { id: "endTestGetEndTestPage", call: endTestGetEndTestPage },
} satisfies EntityOperations;

/** /api/v1/files */
export const filesOps = {
  entity: { endpoint: "files", apiVersion: "v1" },
  detail: { id: "filesLoadFile", call: filesLoadFile, param: "id" },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensor-configuration-groups */
export const fillLevelSensorConfigurationGroupsOps = {
  entity: { endpoint: "fill-level-sensor-configuration-groups", apiVersion: "v1" },
  page: {
    id: "fillLevelSensorConfigurationGroupsGetEntityPage",
    call: fillLevelSensorConfigurationGroupsGetEntityPage,
  },
  create: {
    id: "fillLevelSensorConfigurationGroupsCreateEntity",
    call: fillLevelSensorConfigurationGroupsCreateEntity,
  },
  detail: {
    id: "fillLevelSensorConfigurationGroupsGetEntity",
    call: fillLevelSensorConfigurationGroupsGetEntity,
    param: "id",
  },
  update: {
    id: "fillLevelSensorConfigurationGroupsUpdateEntity",
    call: fillLevelSensorConfigurationGroupsUpdateEntity,
    param: "id",
  },
  remove: {
    id: "fillLevelSensorConfigurationGroupsDeleteEntity",
    call: fillLevelSensorConfigurationGroupsDeleteEntity,
    param: "id",
  },
  list: { id: "fillLevelSensorConfigurationGroupsListEntities", call: fillLevelSensorConfigurationGroupsListEntities },
  valueUsed: {
    id: "fillLevelSensorConfigurationGroupsIsValueUsed",
    call: fillLevelSensorConfigurationGroupsIsValueUsed,
  },
  containersPartial: {
    id: "fillLevelSensorConfigurationGroupsUpdateContainersGroup",
    call: fillLevelSensorConfigurationGroupsUpdateContainersGroup,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensor-configuration-groups/list */
export const fillLevelSensorConfigurationGroupsListOps = {
  entity: { endpoint: "fill-level-sensor-configuration-groups/list", apiVersion: "v1" },
  page: { id: "fillLevelSensorConfigurationGroupsListEntities", call: fillLevelSensorConfigurationGroupsListEntities },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensor-configuration-groups/value-used */
export const fillLevelSensorConfigurationGroupsValueUsedOps = {
  entity: { endpoint: "fill-level-sensor-configuration-groups/value-used", apiVersion: "v1" },
  create: { id: "fillLevelSensorConfigurationGroupsIsValueUsed", call: fillLevelSensorConfigurationGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensor-types */
export const fillLevelSensorTypesOps = {
  entity: { endpoint: "fill-level-sensor-types", apiVersion: "v1" },
  list: { id: "fillLevelSensorTypesListFillLevelSensorTypes", call: fillLevelSensorTypesListFillLevelSensorTypes },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensor-types/list */
export const fillLevelSensorTypesListOps = {
  entity: { endpoint: "fill-level-sensor-types/list", apiVersion: "v1" },
  page: { id: "fillLevelSensorTypesListFillLevelSensorTypes", call: fillLevelSensorTypesListFillLevelSensorTypes },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensors */
export const fillLevelSensorsOps = {
  entity: { endpoint: "fill-level-sensors", apiVersion: "v1" },
  page: { id: "fillLevelSensorsGetEntityPage", call: fillLevelSensorsGetEntityPage },
  create: { id: "fillLevelSensorsCreateEntity", call: fillLevelSensorsCreateEntity },
  detail: { id: "fillLevelSensorsGetEntity", call: fillLevelSensorsGetEntity, param: "id" },
  update: { id: "fillLevelSensorsUpdateEntity", call: fillLevelSensorsUpdateEntity, param: "id" },
  remove: { id: "fillLevelSensorsDeleteFillLevelSensor", call: fillLevelSensorsDeleteFillLevelSensor, param: "id" },
  activate: {
    id: "fillLevelSensorsActivateFillLevelSensor",
    call: fillLevelSensorsActivateFillLevelSensor,
    param: "id",
  },
  list: { id: "fillLevelSensorsListEntities", call: fillLevelSensorsListEntities },
  valueUsed: { id: "fillLevelSensorsIsValueUsed", call: fillLevelSensorsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensors/containers */
export const fillLevelSensorsContainersOps = {
  entity: { endpoint: "fill-level-sensors/containers", apiVersion: "v1" },
  page: { id: "fillLevelSensorsGetContainersPage", call: fillLevelSensorsGetContainersPage },
  export: { id: "fillLevelSensorsExportList", call: fillLevelSensorsExportList, param: "format" },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensors/list */
export const fillLevelSensorsListOps = {
  entity: { endpoint: "fill-level-sensors/list", apiVersion: "v1" },
  page: { id: "fillLevelSensorsListEntities", call: fillLevelSensorsListEntities },
} satisfies EntityOperations;

/** /api/v1/fill-level-sensors/value-used */
export const fillLevelSensorsValueUsedOps = {
  entity: { endpoint: "fill-level-sensors/value-used", apiVersion: "v1" },
  create: { id: "fillLevelSensorsIsValueUsed", call: fillLevelSensorsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/firmware */
export const firmwareOps = {
  entity: { endpoint: "firmware", apiVersion: "v1" },
  page: { id: "firmwareGetEntityPage", call: firmwareGetEntityPage },
  create: { id: "firmwareUploadFirmware", call: firmwareUploadFirmware },
  detail: { id: "firmwareGetEntity", call: firmwareGetEntity, param: "id" },
  update: { id: "firmwareUpdateEntity", call: firmwareUpdateEntity, param: "id" },
  remove: { id: "firmwareDeleteEntity", call: firmwareDeleteEntity, param: "id" },
  activate: { id: "firmwareActivateEntity", call: firmwareActivateEntity, param: "id" },
  list: { id: "firmwareListEntities", call: firmwareListEntities },
} satisfies EntityOperations;

/** /api/v1/firmware/list */
export const firmwareListOps = {
  entity: { endpoint: "firmware/list", apiVersion: "v1" },
  page: { id: "firmwareListEntities", call: firmwareListEntities },
} satisfies EntityOperations;

/** /api/v1/fraction-configuration-groups */
export const fractionConfigurationGroupsOps = {
  entity: { endpoint: "fraction-configuration-groups", apiVersion: "v1" },
  page: { id: "fractionConfigurationGroupsGetEntityPage", call: fractionConfigurationGroupsGetEntityPage },
  create: { id: "fractionConfigurationGroupsCreateEntity", call: fractionConfigurationGroupsCreateEntity },
  detail: { id: "fractionConfigurationGroupsGetEntity", call: fractionConfigurationGroupsGetEntity, param: "id" },
  update: { id: "fractionConfigurationGroupsUpdateEntity", call: fractionConfigurationGroupsUpdateEntity, param: "id" },
  remove: { id: "fractionConfigurationGroupsDeleteEntity", call: fractionConfigurationGroupsDeleteEntity, param: "id" },
  list: { id: "fractionConfigurationGroupsListEntities", call: fractionConfigurationGroupsListEntities },
  valueUsed: { id: "fractionConfigurationGroupsIsValueUsed", call: fractionConfigurationGroupsIsValueUsed },
  containersPartial: {
    id: "fractionConfigurationGroupsUpdateContainersGroup",
    call: fractionConfigurationGroupsUpdateContainersGroup,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/fraction-configuration-groups/list */
export const fractionConfigurationGroupsListOps = {
  entity: { endpoint: "fraction-configuration-groups/list", apiVersion: "v1" },
  page: { id: "fractionConfigurationGroupsListEntities", call: fractionConfigurationGroupsListEntities },
} satisfies EntityOperations;

/** /api/v1/fraction-configuration-groups/value-used */
export const fractionConfigurationGroupsValueUsedOps = {
  entity: { endpoint: "fraction-configuration-groups/value-used", apiVersion: "v1" },
  create: { id: "fractionConfigurationGroupsIsValueUsed", call: fractionConfigurationGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/geozones */
export const geozonesOps = {
  entity: { endpoint: "geozones", apiVersion: "v1" },
  page: { id: "geozonesGetEntityPage", call: geozonesGetEntityPage },
  create: { id: "geozonesCreateEntity", call: geozonesCreateEntity },
  detail: { id: "geozonesGetEntity", call: geozonesGetEntity, param: "id" },
  update: { id: "geozonesUpdateEntity", call: geozonesUpdateEntity, param: "id" },
  remove: { id: "geozonesDeleteEntity", call: geozonesDeleteEntity, param: "id" },
  valueUsed: { id: "geozonesIsValueUsed", call: geozonesIsValueUsed },
  containersPartial: { id: "geozonesUpdateContainersGroup", call: geozonesUpdateContainersGroup, param: "id" },
} satisfies EntityOperations;

/** /api/v1/geozones/value-used */
export const geozonesValueUsedOps = {
  entity: { endpoint: "geozones/value-used", apiVersion: "v1" },
  create: { id: "geozonesIsValueUsed", call: geozonesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/hardware-commands */
export const hardwareCommandsOps = {
  entity: { endpoint: "hardware-commands", apiVersion: "v1" },
  page: { id: "hardwareCommandsGetEntityPage", call: hardwareCommandsGetEntityPage },
  create: { id: "hardwareCommandsCreateEntity", call: hardwareCommandsCreateEntity },
  detail: { id: "hardwareCommandsGetEntity", call: hardwareCommandsGetEntity, param: "id" },
} satisfies EntityOperations;

/** /api/v1/hardware-unit-configuration-checks */
export const hardwareUnitConfigurationChecksOps = {
  entity: { endpoint: "hardware-unit-configuration-checks", apiVersion: "v1" },
  detail: {
    id: "hardwareUnitConfigurationChecksGetConfigurationSnapshot",
    call: hardwareUnitConfigurationChecksGetConfigurationSnapshot,
    param: "hardwareUnitId",
  },
} satisfies EntityOperations;

/** /api/v1/hardware-unit-log-messages */
export const hardwareUnitLogMessagesOps = {
  entity: { endpoint: "hardware-unit-log-messages", apiVersion: "v1" },
  page: { id: "hardwareUnitLogMessagesGetMessagesPage", call: hardwareUnitLogMessagesGetMessagesPage },
} satisfies EntityOperations;

/** /api/v1/hardware-unit-log-messages/import */
export const hardwareUnitLogMessagesImportOps = {
  entity: { endpoint: "hardware-unit-log-messages/import", apiVersion: "v1" },
  create: { id: "hardwareUnitLogMessagesImportLogMessages", call: hardwareUnitLogMessagesImportLogMessages },
} satisfies EntityOperations;

/** /api/v1/hardware-unit-log-messages/import/validate */
export const hardwareUnitLogMessagesImportValidateOps = {
  entity: { endpoint: "hardware-unit-log-messages/import/validate", apiVersion: "v1" },
  create: {
    id: "hardwareUnitLogMessagesValidateHardwareUnitLogImport",
    call: hardwareUnitLogMessagesValidateHardwareUnitLogImport,
  },
} satisfies EntityOperations;

/** /api/v1/hardware-unit-log-messages/modules */
export const hardwareUnitLogMessagesModulesOps = {
  entity: { endpoint: "hardware-unit-log-messages/modules", apiVersion: "v1" },
  list: { id: "hardwareUnitLogMessagesGetListOfModules", call: hardwareUnitLogMessagesGetListOfModules },
} satisfies EntityOperations;

/** /api/v1/hardware-unit-log-messages/modules/list */
export const hardwareUnitLogMessagesModulesListOps = {
  entity: { endpoint: "hardware-unit-log-messages/modules/list", apiVersion: "v1" },
  page: { id: "hardwareUnitLogMessagesGetListOfModules", call: hardwareUnitLogMessagesGetListOfModules },
} satisfies EntityOperations;

/** /api/v1/hardware-units */
export const hardwareUnitsOps = {
  entity: { endpoint: "hardware-units", apiVersion: "v1" },
  page: { id: "hardwareUnitsGetEntityPage", call: hardwareUnitsGetEntityPage },
  detail: { id: "hardwareUnitsGetEntity", call: hardwareUnitsGetEntity, param: "id" },
  update: { id: "hardwareUnitsUpdateEntity", call: hardwareUnitsUpdateEntity, param: "id" },
  list: { id: "hardwareUnitsListHardwareUnits", call: hardwareUnitsListHardwareUnits },
  export: { id: "hardwareUnitsExport", call: hardwareUnitsExport, param: "format" },
  log: { id: "hardwareUnitsGetLog", call: hardwareUnitsGetLog, param: "id" },
} satisfies EntityOperations;

/** /api/v1/hardware-units/end-tests */
export const hardwareUnitsEndTestsOps = {
  entity: { endpoint: "hardware-units/end-tests", apiVersion: "v1" },
  page: { id: "hardwareUnitsGetEndTestResults", call: hardwareUnitsGetEndTestResults },
} satisfies EntityOperations;

/** /api/v1/hardware-units/list */
export const hardwareUnitsListOps = {
  entity: { endpoint: "hardware-units/list", apiVersion: "v1" },
  page: { id: "hardwareUnitsListHardwareUnits", call: hardwareUnitsListHardwareUnits },
} satisfies EntityOperations;

/** /api/v1/hardware-units/list-for-service-user */
export const hardwareUnitsListForServiceUserOps = {
  entity: { endpoint: "hardware-units/list-for-service-user", apiVersion: "v1" },
  page: { id: "hardwareUnitsListHardwareUnitsForServiceUser", call: hardwareUnitsListHardwareUnitsForServiceUser },
} satisfies EntityOperations;

/** /api/v1/hardware-units/list-paged */
export const hardwareUnitsListPagedOps = {
  entity: { endpoint: "hardware-units/list-paged", apiVersion: "v1" },
  page: { id: "hardwareUnitsListPagedHardwareUnits", call: hardwareUnitsListPagedHardwareUnits },
} satisfies EntityOperations;

/** /api/v1/hardware-units/telemetry */
export const hardwareUnitsTelemetryOps = {
  entity: { endpoint: "hardware-units/telemetry", apiVersion: "v1" },
  export: {
    id: "hardwareUnitsExportMultiTelemetryHistory",
    call: hardwareUnitsExportMultiTelemetryHistory,
    param: "format",
  },
} satisfies EntityOperations;

/** /api/v1/images */
export const imagesOps = {
  entity: { endpoint: "images", apiVersion: "v1" },
  create: { id: "imagesUploadImage", call: imagesUploadImage },
  detail: { id: "imagesShowImage", call: imagesShowImage, param: "id" },
} satisfies EntityOperations;

/** /api/v1/interval-configuration-groups */
export const intervalConfigurationGroupsOps = {
  entity: { endpoint: "interval-configuration-groups", apiVersion: "v1" },
  page: { id: "intervalConfigurationGroupsGetEntityPage", call: intervalConfigurationGroupsGetEntityPage },
  create: { id: "intervalConfigurationGroupsCreateEntity", call: intervalConfigurationGroupsCreateEntity },
  detail: { id: "intervalConfigurationGroupsGetEntity", call: intervalConfigurationGroupsGetEntity, param: "id" },
  update: { id: "intervalConfigurationGroupsUpdateEntity", call: intervalConfigurationGroupsUpdateEntity, param: "id" },
  remove: { id: "intervalConfigurationGroupsDeleteEntity", call: intervalConfigurationGroupsDeleteEntity, param: "id" },
  list: { id: "intervalConfigurationGroupsListEntities", call: intervalConfigurationGroupsListEntities },
  valueUsed: { id: "intervalConfigurationGroupsIsValueUsed", call: intervalConfigurationGroupsIsValueUsed },
  containersPartial: {
    id: "intervalConfigurationGroupsUpdateContainersGroup",
    call: intervalConfigurationGroupsUpdateContainersGroup,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/interval-configuration-groups/list */
export const intervalConfigurationGroupsListOps = {
  entity: { endpoint: "interval-configuration-groups/list", apiVersion: "v1" },
  page: { id: "intervalConfigurationGroupsListEntities", call: intervalConfigurationGroupsListEntities },
} satisfies EntityOperations;

/** /api/v1/interval-configuration-groups/value-used */
export const intervalConfigurationGroupsValueUsedOps = {
  entity: { endpoint: "interval-configuration-groups/value-used", apiVersion: "v1" },
  create: { id: "intervalConfigurationGroupsIsValueUsed", call: intervalConfigurationGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/issues */
export const issuesOps = {
  entity: { endpoint: "issues", apiVersion: "v1" },
  page: { id: "issuesGetIssuesPage", call: issuesGetIssuesPage },
  create: { id: "issuesCreateIssue", call: issuesCreateIssue },
  detail: { id: "issuesGetIssue", call: issuesGetIssue, param: "id" },
  export: { id: "issuesExportList", call: issuesExportList, param: "format" },
} satisfies EntityOperations;

/** /api/v1/issues/types */
export const issuesTypesOps = {
  entity: { endpoint: "issues/types", apiVersion: "v1" },
  page: { id: "issuesListIssueTypes", call: issuesListIssueTypes },
} satisfies EntityOperations;

/** /api/v1/languages */
export const languagesOps = {
  entity: { endpoint: "languages", apiVersion: "v1" },
  page: { id: "languagesListLanguages", call: languagesListLanguages },
} satisfies EntityOperations;

/** /api/v1/large-lists */
export const largeListsOps = {
  entity: { endpoint: "large-lists", apiVersion: "v1" },
  page: { id: "largeListsGetEntityPage", call: largeListsGetEntityPage },
  create: { id: "largeListsCreateEntity", call: largeListsCreateEntity },
  detail: { id: "largeListsGetEntity", call: largeListsGetEntity, param: "id" },
  update: { id: "largeListsUpdateEntity", call: largeListsUpdateEntity, param: "id" },
  remove: { id: "largeListsDeleteEntity", call: largeListsDeleteEntity, param: "id" },
  activate: { id: "largeListsActivateEntity", call: largeListsActivateEntity, param: "id" },
  list: { id: "largeListsListEntities", call: largeListsListEntities },
  valueUsed: { id: "largeListsIsValueUsed", call: largeListsIsValueUsed },
  containersPartial: { id: "largeListsUpdateContainers", call: largeListsUpdateContainers, param: "id" },
} satisfies EntityOperations;

/** /api/v1/large-lists/list */
export const largeListsListOps = {
  entity: { endpoint: "large-lists/list", apiVersion: "v1" },
  page: { id: "largeListsListEntities", call: largeListsListEntities },
} satisfies EntityOperations;

/** /api/v1/large-lists/template/large-list.csv */
export const largeListsTemplateLargeListCsvOps = {
  entity: { endpoint: "large-lists/template/large-list.csv", apiVersion: "v1" },
  page: { id: "largeListsGetImportTemplateContractContainers", call: largeListsGetImportTemplateContractContainers },
} satisfies EntityOperations;

/** /api/v1/large-lists/value-used */
export const largeListsValueUsedOps = {
  entity: { endpoint: "large-lists/value-used", apiVersion: "v1" },
  create: { id: "largeListsIsValueUsed", call: largeListsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/lifting-systems */
export const liftingSystemsOps = {
  entity: { endpoint: "lifting-systems", apiVersion: "v1" },
  page: { id: "liftingSystemsGetEntityPage", call: liftingSystemsGetEntityPage },
  create: { id: "liftingSystemsCreateEntity", call: liftingSystemsCreateEntity },
  detail: { id: "liftingSystemsGetEntity", call: liftingSystemsGetEntity, param: "id" },
  update: { id: "liftingSystemsUpdateEntity", call: liftingSystemsUpdateEntity, param: "id" },
  remove: { id: "liftingSystemsDeleteEntity", call: liftingSystemsDeleteEntity, param: "id" },
  list: { id: "liftingSystemsListEntities", call: liftingSystemsListEntities },
} satisfies EntityOperations;

/** /api/v1/lifting-systems/list */
export const liftingSystemsListOps = {
  entity: { endpoint: "lifting-systems/list", apiVersion: "v1" },
  page: { id: "liftingSystemsListEntities", call: liftingSystemsListEntities },
} satisfies EntityOperations;

/** /api/v1/location-tracker-types */
export const locationTrackerTypesOps = {
  entity: { endpoint: "location-tracker-types", apiVersion: "v1" },
  list: { id: "locationTrackerTypesListLocationTrackerTypes", call: locationTrackerTypesListLocationTrackerTypes },
} satisfies EntityOperations;

/** /api/v1/location-tracker-types/list */
export const locationTrackerTypesListOps = {
  entity: { endpoint: "location-tracker-types/list", apiVersion: "v1" },
  page: { id: "locationTrackerTypesListLocationTrackerTypes", call: locationTrackerTypesListLocationTrackerTypes },
} satisfies EntityOperations;

/** /api/v1/location-trackers */
export const locationTrackersOps = {
  entity: { endpoint: "location-trackers", apiVersion: "v1" },
  page: { id: "locationTrackersGetEntityPage", call: locationTrackersGetEntityPage },
  create: { id: "locationTrackersCreateEntity", call: locationTrackersCreateEntity },
  detail: { id: "locationTrackersGetEntity", call: locationTrackersGetEntity, param: "id" },
  update: { id: "locationTrackersUpdateEntity", call: locationTrackersUpdateEntity, param: "id" },
  remove: { id: "locationTrackersDeleteEntity", call: locationTrackersDeleteEntity, param: "id" },
  activate: { id: "locationTrackersActivateEntity", call: locationTrackersActivateEntity, param: "id" },
  list: { id: "locationTrackersListEntities", call: locationTrackersListEntities },
  valueUsed: { id: "locationTrackersIsValueUsed", call: locationTrackersIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/location-trackers/list */
export const locationTrackersListOps = {
  entity: { endpoint: "location-trackers/list", apiVersion: "v1" },
  page: { id: "locationTrackersListEntities", call: locationTrackersListEntities },
} satisfies EntityOperations;

/** /api/v1/location-trackers/value-used */
export const locationTrackersValueUsedOps = {
  entity: { endpoint: "location-trackers/value-used", apiVersion: "v1" },
  create: { id: "locationTrackersIsValueUsed", call: locationTrackersIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/materials */
export const materialsOps = {
  entity: { endpoint: "materials", apiVersion: "v1" },
  page: { id: "materialsGetEntityPage", call: materialsGetEntityPage },
  create: { id: "materialsCreateEntity", call: materialsCreateEntity },
  detail: { id: "materialsGetEntity", call: materialsGetEntity, param: "id" },
  update: { id: "materialsUpdateEntity", call: materialsUpdateEntity, param: "id" },
  remove: { id: "materialsDeleteEntity", call: materialsDeleteEntity, param: "id" },
  list: { id: "materialsListMaterials", call: materialsListMaterials },
  valueUsed: { id: "materialsIsValueUsed", call: materialsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/materials/list */
export const materialsListOps = {
  entity: { endpoint: "materials/list", apiVersion: "v1" },
  page: { id: "materialsListMaterials", call: materialsListMaterials },
} satisfies EntityOperations;

/** /api/v1/materials/value-used */
export const materialsValueUsedOps = {
  entity: { endpoint: "materials/value-used", apiVersion: "v1" },
  create: { id: "materialsIsValueUsed", call: materialsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/me */
export const meOps = {
  entity: { endpoint: "me", apiVersion: "v1" },
  page: { id: "meGetUserProfile", call: meGetUserProfile },
} satisfies EntityOperations;

/** /api/v1/me/containers */
export const meContainersOps = {
  entity: { endpoint: "me/containers", apiVersion: "v1" },
  page: { id: "meGetContainers", call: meGetContainers },
} satisfies EntityOperations;

/** /api/v1/me/features */
export const meFeaturesOps = {
  entity: { endpoint: "me/features", apiVersion: "v1" },
  page: { id: "meGetFeatures", call: meGetFeatures },
} satisfies EntityOperations;

/** /api/v1/me/map */
export const meMapOps = {
  entity: { endpoint: "me/map", apiVersion: "v1" },
  page: { id: "meGetContainerMap", call: meGetContainerMap },
} satisfies EntityOperations;

/** /api/v1/me/messages */
export const meMessagesOps = {
  entity: { endpoint: "me/messages", apiVersion: "v1" },
  page: { id: "meGetMessages", call: meGetMessages },
} satisfies EntityOperations;

/** /api/v1/me/reports/transaction-fraction-totals */
export const meReportsTransactionFractionTotalsOps = {
  entity: { endpoint: "me/reports/transaction-fraction-totals", apiVersion: "v1" },
  page: { id: "meGetUserTransactionTotalsByFraction", call: meGetUserTransactionTotalsByFraction },
} satisfies EntityOperations;

/** /api/v1/me/reports/transaction-fraction-totals/detailed */
export const meReportsTransactionFractionTotalsDetailedOps = {
  entity: { endpoint: "me/reports/transaction-fraction-totals/detailed", apiVersion: "v1" },
  page: { id: "meGetUserTransactionTotalsByFractionDetailed", call: meGetUserTransactionTotalsByFractionDetailed },
} satisfies EntityOperations;

/** /api/v1/me/reports/transaction-fractions */
export const meReportsTransactionFractionsOps = {
  entity: { endpoint: "me/reports/transaction-fractions", apiVersion: "v1" },
  page: { id: "meGetUserTransactionFraction", call: meGetUserTransactionFraction },
} satisfies EntityOperations;

/** /api/v1/me/reports/transaction-source-totals */
export const meReportsTransactionSourceTotalsOps = {
  entity: { endpoint: "me/reports/transaction-source-totals", apiVersion: "v1" },
  page: { id: "meGetUserTransactionTotalsBySource", call: meGetUserTransactionTotalsBySource },
} satisfies EntityOperations;

/** /api/v1/me/reports/transaction-totals */
export const meReportsTransactionTotalsOps = {
  entity: { endpoint: "me/reports/transaction-totals", apiVersion: "v1" },
  page: { id: "meGetUserTransactionTotals", call: meGetUserTransactionTotals },
} satisfies EntityOperations;

/** /api/v1/me/reports/transaction-totals/detailed */
export const meReportsTransactionTotalsDetailedOps = {
  entity: { endpoint: "me/reports/transaction-totals/detailed", apiVersion: "v1" },
  page: { id: "meGetUserTransactionTotalsDetailed", call: meGetUserTransactionTotalsDetailed },
} satisfies EntityOperations;

/** /api/v1/me/reports/transactions-daily-count */
export const meReportsTransactionsDailyCountOps = {
  entity: { endpoint: "me/reports/transactions-daily-count", apiVersion: "v1" },
  page: { id: "meGetTransactionsDailyCountReport", call: meGetTransactionsDailyCountReport },
} satisfies EntityOperations;

/** /api/v1/me/transactions */
export const meTransactionsOps = {
  entity: { endpoint: "me/transactions", apiVersion: "v1" },
  page: { id: "meGetTransactions", call: meGetTransactions },
} satisfies EntityOperations;

/** /api/v1/mifare-data-read-frame */
export const mifareDataReadFrameOps = {
  entity: { endpoint: "mifare-data-read-frame", apiVersion: "v1" },
  page: { id: "mifareDataReadFrameGetEntityPage", call: mifareDataReadFrameGetEntityPage },
  create: { id: "mifareDataReadFrameCreateEntity", call: mifareDataReadFrameCreateEntity },
  detail: { id: "mifareDataReadFrameGetEntity", call: mifareDataReadFrameGetEntity, param: "id" },
  update: { id: "mifareDataReadFrameUpdateEntity", call: mifareDataReadFrameUpdateEntity, param: "id" },
  remove: { id: "mifareDataReadFrameDeleteEntity", call: mifareDataReadFrameDeleteEntity, param: "id" },
  list: { id: "mifareDataReadFrameListEntities", call: mifareDataReadFrameListEntities },
  valueUsed: { id: "mifareDataReadFrameIsValueUsed", call: mifareDataReadFrameIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/mifare-data-read-frame/list */
export const mifareDataReadFrameListOps = {
  entity: { endpoint: "mifare-data-read-frame/list", apiVersion: "v1" },
  page: { id: "mifareDataReadFrameListEntities", call: mifareDataReadFrameListEntities },
} satisfies EntityOperations;

/** /api/v1/mifare-data-read-frame/value-used */
export const mifareDataReadFrameValueUsedOps = {
  entity: { endpoint: "mifare-data-read-frame/value-used", apiVersion: "v1" },
  create: { id: "mifareDataReadFrameIsValueUsed", call: mifareDataReadFrameIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/nfc-card-blacklists */
export const nfcCardBlacklistsOps = {
  entity: { endpoint: "nfc-card-blacklists", apiVersion: "v1" },
  page: { id: "nfcCardBlacklistsGetEntityPage", call: nfcCardBlacklistsGetEntityPage },
  create: { id: "nfcCardBlacklistsCreateEntity", call: nfcCardBlacklistsCreateEntity },
  detail: { id: "nfcCardBlacklistsGetEntity", call: nfcCardBlacklistsGetEntity, param: "id" },
  update: { id: "nfcCardBlacklistsUpdateEntity", call: nfcCardBlacklistsUpdateEntity, param: "id" },
  remove: { id: "nfcCardBlacklistsDeleteEntity", call: nfcCardBlacklistsDeleteEntity, param: "id" },
  list: { id: "nfcCardBlacklistsListEntities", call: nfcCardBlacklistsListEntities },
  valueUsed: { id: "nfcCardBlacklistsIsValueUsed", call: nfcCardBlacklistsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/nfc-card-blacklists/list */
export const nfcCardBlacklistsListOps = {
  entity: { endpoint: "nfc-card-blacklists/list", apiVersion: "v1" },
  page: { id: "nfcCardBlacklistsListEntities", call: nfcCardBlacklistsListEntities },
} satisfies EntityOperations;

/** /api/v1/nfc-card-blacklists/value-used */
export const nfcCardBlacklistsValueUsedOps = {
  entity: { endpoint: "nfc-card-blacklists/value-used", apiVersion: "v1" },
  create: { id: "nfcCardBlacklistsIsValueUsed", call: nfcCardBlacklistsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/nfc-card-configuration-groups */
export const nfcCardConfigurationGroupsOps = {
  entity: { endpoint: "nfc-card-configuration-groups", apiVersion: "v1" },
  page: { id: "nfcCardConfigurationGroupsGetEntityPage", call: nfcCardConfigurationGroupsGetEntityPage },
  create: { id: "nfcCardConfigurationGroupsCreateEntity", call: nfcCardConfigurationGroupsCreateEntity },
  detail: { id: "nfcCardConfigurationGroupsGetEntity", call: nfcCardConfigurationGroupsGetEntity, param: "id" },
  update: { id: "nfcCardConfigurationGroupsUpdateEntity", call: nfcCardConfigurationGroupsUpdateEntity, param: "id" },
  remove: { id: "nfcCardConfigurationGroupsDeleteEntity", call: nfcCardConfigurationGroupsDeleteEntity, param: "id" },
  list: { id: "nfcCardConfigurationGroupsListEntities", call: nfcCardConfigurationGroupsListEntities },
  valueUsed: { id: "nfcCardConfigurationGroupsIsValueUsed", call: nfcCardConfigurationGroupsIsValueUsed },
  containersPartial: {
    id: "nfcCardConfigurationGroupsUpdateContainersGroup",
    call: nfcCardConfigurationGroupsUpdateContainersGroup,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/nfc-card-configuration-groups/eligible-containers */
export const nfcCardConfigurationGroupsEligibleContainersOps = {
  entity: { endpoint: "nfc-card-configuration-groups/eligible-containers", apiVersion: "v1" },
  page: { id: "nfcCardConfigurationGroupsListEligible", call: nfcCardConfigurationGroupsListEligible },
} satisfies EntityOperations;

/** /api/v1/nfc-card-configuration-groups/list */
export const nfcCardConfigurationGroupsListOps = {
  entity: { endpoint: "nfc-card-configuration-groups/list", apiVersion: "v1" },
  page: { id: "nfcCardConfigurationGroupsListEntities", call: nfcCardConfigurationGroupsListEntities },
} satisfies EntityOperations;

/** /api/v1/nfc-card-configuration-groups/value-used */
export const nfcCardConfigurationGroupsValueUsedOps = {
  entity: { endpoint: "nfc-card-configuration-groups/value-used", apiVersion: "v1" },
  create: { id: "nfcCardConfigurationGroupsIsValueUsed", call: nfcCardConfigurationGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/nfc-cards */
export const nfcCardsOps = {
  entity: { endpoint: "nfc-cards", apiVersion: "v1" },
  page: { id: "nfcCardsGetEntityPage", call: nfcCardsGetEntityPage },
  create: { id: "nfcCardsCreateEntity", call: nfcCardsCreateEntity },
  detail: { id: "nfcCardsGetEntity", call: nfcCardsGetEntity, param: "id" },
  update: { id: "nfcCardsUpdateEntity", call: nfcCardsUpdateEntity, param: "id" },
  activate: { id: "nfcCardsActivateEntity", call: nfcCardsActivateEntity, param: "id" },
  list: { id: "nfcCardsListEntities", call: nfcCardsListEntities },
  export: { id: "nfcCardsExportList", call: nfcCardsExportList, param: "format" },
  valueUsed: { id: "nfcCardsIsValueUsed", call: nfcCardsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/nfc-cards/authentication-types */
export const nfcCardsAuthenticationTypesOps = {
  entity: { endpoint: "nfc-cards/authentication-types", apiVersion: "v1" },
  page: { id: "nfcCardsListCardAuthenticationTypes", call: nfcCardsListCardAuthenticationTypes },
} satisfies EntityOperations;

/** /api/v1/nfc-cards/generate-ble-keys */
export const nfcCardsGenerateBleKeysOps = {
  entity: { endpoint: "nfc-cards/generate-ble-keys", apiVersion: "v1" },
  create: { id: "nfcCardsGenerateBleKeys", call: nfcCardsGenerateBleKeys },
} satisfies EntityOperations;

/** /api/v1/nfc-cards/list */
export const nfcCardsListOps = {
  entity: { endpoint: "nfc-cards/list", apiVersion: "v1" },
  page: { id: "nfcCardsListEntities", call: nfcCardsListEntities },
} satisfies EntityOperations;

/** /api/v1/nfc-cards/reader-types */
export const nfcCardsReaderTypesOps = {
  entity: { endpoint: "nfc-cards/reader-types", apiVersion: "v1" },
  page: { id: "nfcCardsListCardReaderTypes", call: nfcCardsListCardReaderTypes },
} satisfies EntityOperations;

/** /api/v1/nfc-cards/types */
export const nfcCardsTypesOps = {
  entity: { endpoint: "nfc-cards/types", apiVersion: "v1" },
  page: { id: "nfcCardsListCardTypes", call: nfcCardsListCardTypes },
} satisfies EntityOperations;

/** /api/v1/nfc-cards/value-used */
export const nfcCardsValueUsedOps = {
  entity: { endpoint: "nfc-cards/value-used", apiVersion: "v1" },
  create: { id: "nfcCardsIsValueUsed", call: nfcCardsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/notification-settings */
export const notificationSettingsOps = {
  entity: { endpoint: "notification-settings", apiVersion: "v1" },
  create: { id: "notificationSettingsCreateNotificationSetting", call: notificationSettingsCreateNotificationSetting },
  detail: {
    id: "notificationSettingsGetNotificationSetting",
    call: notificationSettingsGetNotificationSetting,
    param: "id",
  },
  update: {
    id: "notificationSettingsUpdateNotificationSetting",
    call: notificationSettingsUpdateNotificationSetting,
    param: "id",
  },
  remove: {
    id: "notificationSettingsDeleteNotificationSetting",
    call: notificationSettingsDeleteNotificationSetting,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/permission-groups */
export const permissionGroupsOps = {
  entity: { endpoint: "permission-groups", apiVersion: "v1" },
  page: { id: "permissionGroupsGetEntityPage", call: permissionGroupsGetEntityPage },
  create: { id: "permissionGroupsCreateEntity", call: permissionGroupsCreateEntity },
  detail: { id: "permissionGroupsGetEntity", call: permissionGroupsGetEntity, param: "id" },
  update: { id: "permissionGroupsUpdateEntity", call: permissionGroupsUpdateEntity, param: "id" },
  remove: { id: "permissionGroupsDeleteEntity", call: permissionGroupsDeleteEntity, param: "id" },
  list: { id: "permissionGroupsListEntities", call: permissionGroupsListEntities },
  valueUsed: { id: "permissionGroupsIsValueUsed", call: permissionGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/permission-groups/effective-roles */
export const permissionGroupsEffectiveRolesOps = {
  entity: { endpoint: "permission-groups/effective-roles", apiVersion: "v1" },
  page: { id: "permissionGroupsGetEffectiveRolesByGroupIds", call: permissionGroupsGetEffectiveRolesByGroupIds },
} satisfies EntityOperations;

/** /api/v1/permission-groups/list */
export const permissionGroupsListOps = {
  entity: { endpoint: "permission-groups/list", apiVersion: "v1" },
  page: { id: "permissionGroupsListEntities", call: permissionGroupsListEntities },
} satisfies EntityOperations;

/** /api/v1/permission-groups/value-used */
export const permissionGroupsValueUsedOps = {
  entity: { endpoint: "permission-groups/value-used", apiVersion: "v1" },
  create: { id: "permissionGroupsIsValueUsed", call: permissionGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/products */
export const productsOps = {
  entity: { endpoint: "products", apiVersion: "v1" },
  page: { id: "productsGetEntityPage", call: productsGetEntityPage },
  create: { id: "productsCreateEntity", call: productsCreateEntity },
  detail: { id: "productsGetEntity", call: productsGetEntity, param: "id" },
  update: { id: "productsUpdateEntity", call: productsUpdateEntity, param: "id" },
  remove: { id: "productsDeleteEntity", call: productsDeleteEntity, param: "id" },
  list: { id: "productsListEntities", call: productsListEntities },
  valueUsed: { id: "productsIsValueUsed", call: productsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/products/by-part */
export const productsByPartOps = {
  entity: { endpoint: "products/by-part", apiVersion: "v1" },
  detail: { id: "productsGetByPartNumber", call: productsGetByPartNumber, param: "partNumber" },
} satisfies EntityOperations;

/** /api/v1/products/list */
export const productsListOps = {
  entity: { endpoint: "products/list", apiVersion: "v1" },
  page: { id: "productsListEntities", call: productsListEntities },
} satisfies EntityOperations;

/** /api/v1/products/value-used */
export const productsValueUsedOps = {
  entity: { endpoint: "products/value-used", apiVersion: "v1" },
  create: { id: "productsIsValueUsed", call: productsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/region-codes */
export const regionCodesOps = {
  entity: { endpoint: "region-codes", apiVersion: "v1" },
  page: { id: "regionCodesGetEntityPage", call: regionCodesGetEntityPage },
  create: { id: "regionCodesCreateEntity", call: regionCodesCreateEntity },
  detail: { id: "regionCodesGetEntity", call: regionCodesGetEntity, param: "id" },
  update: { id: "regionCodesUpdateEntity", call: regionCodesUpdateEntity, param: "id" },
  remove: { id: "regionCodesDeleteEntity", call: regionCodesDeleteEntity, param: "id" },
  list: { id: "regionCodesListEntities", call: regionCodesListEntities },
  export: { id: "regionCodesExportList", call: regionCodesExportList, param: "format" },
  valueUsed: { id: "regionCodesIsValueUsed", call: regionCodesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/region-codes-configuration-groups */
export const regionCodesConfigurationGroupsOps = {
  entity: { endpoint: "region-codes-configuration-groups", apiVersion: "v1" },
  page: { id: "regionCodesConfigurationGroupsGetEntityPage", call: regionCodesConfigurationGroupsGetEntityPage },
  create: { id: "regionCodesConfigurationGroupsCreateEntity", call: regionCodesConfigurationGroupsCreateEntity },
  detail: { id: "regionCodesConfigurationGroupsGetEntity", call: regionCodesConfigurationGroupsGetEntity, param: "id" },
  update: {
    id: "regionCodesConfigurationGroupsUpdateEntity",
    call: regionCodesConfigurationGroupsUpdateEntity,
    param: "id",
  },
  remove: {
    id: "regionCodesConfigurationGroupsDeleteEntity",
    call: regionCodesConfigurationGroupsDeleteEntity,
    param: "id",
  },
  list: { id: "regionCodesConfigurationGroupsListEntities", call: regionCodesConfigurationGroupsListEntities },
  valueUsed: { id: "regionCodesConfigurationGroupsIsValueUsed", call: regionCodesConfigurationGroupsIsValueUsed },
  containersPartial: {
    id: "regionCodesConfigurationGroupsUpdateContainersGroup",
    call: regionCodesConfigurationGroupsUpdateContainersGroup,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/region-codes-configuration-groups/list */
export const regionCodesConfigurationGroupsListOps = {
  entity: { endpoint: "region-codes-configuration-groups/list", apiVersion: "v1" },
  page: { id: "regionCodesConfigurationGroupsListEntities", call: regionCodesConfigurationGroupsListEntities },
} satisfies EntityOperations;

/** /api/v1/region-codes-configuration-groups/value-used */
export const regionCodesConfigurationGroupsValueUsedOps = {
  entity: { endpoint: "region-codes-configuration-groups/value-used", apiVersion: "v1" },
  create: { id: "regionCodesConfigurationGroupsIsValueUsed", call: regionCodesConfigurationGroupsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/region-codes/list */
export const regionCodesListOps = {
  entity: { endpoint: "region-codes/list", apiVersion: "v1" },
  page: { id: "regionCodesListEntities", call: regionCodesListEntities },
} satisfies EntityOperations;

/** /api/v1/region-codes/value-used */
export const regionCodesValueUsedOps = {
  entity: { endpoint: "region-codes/value-used", apiVersion: "v1" },
  create: { id: "regionCodesIsValueUsed", call: regionCodesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/reports */
export const reportsOps = {
  entity: { endpoint: "reports", apiVersion: "v1" },
  page: { id: "reportsGetReportsPage", call: reportsGetReportsPage },
  detail: { id: "reportsGetReportConfiguration", call: reportsGetReportConfiguration, param: "id" },
  remove: { id: "reportsDeleteReport", call: reportsDeleteReport, param: "id" },
} satisfies EntityOperations;

/** /api/v1/reports/battery-life */
export const reportsBatteryLifeOps = {
  entity: { endpoint: "reports/battery-life", apiVersion: "v1" },
  page: { id: "reportsGetBatteryLifeReport", call: reportsGetBatteryLifeReport },
  export: { id: "reportsExportList", call: reportsExportList, param: "format" },
} satisfies EntityOperations;

/** /api/v1/reports/battery-life-paged */
export const reportsBatteryLifePagedOps = {
  entity: { endpoint: "reports/battery-life-paged", apiVersion: "v1" },
  page: { id: "reportsGetPagedBatteryLifeReport", call: reportsGetPagedBatteryLifeReport },
} satisfies EntityOperations;

/** /api/v1/reports/emptying-task-list */
export const reportsEmptyingTaskListOps = {
  entity: { endpoint: "reports/emptying-task-list", apiVersion: "v1" },
  create: { id: "reportsCreateTaskListReport", call: reportsCreateTaskListReport },
  update: { id: "reportsUpdateTaskListReport", call: reportsUpdateTaskListReport, param: "id" },
} satisfies EntityOperations;

/** /api/v1/reports/issue-reports-daily-count */
export const reportsIssueReportsDailyCountOps = {
  entity: { endpoint: "reports/issue-reports-daily-count", apiVersion: "v1" },
  page: { id: "reportsGetIssueReportsDailyCountReport", call: reportsGetIssueReportsDailyCountReport },
} satisfies EntityOperations;

/** /api/v1/reports/last-communication */
export const reportsLastCommunicationOps = {
  entity: { endpoint: "reports/last-communication", apiVersion: "v1" },
  page: { id: "reportsGetLastCommunicationReport", call: reportsGetLastCommunicationReport },
} satisfies EntityOperations;

/** /api/v1/reports/last-communication-fls */
export const reportsLastCommunicationFlsOps = {
  entity: { endpoint: "reports/last-communication-fls", apiVersion: "v1" },
  page: { id: "reportsGetLastCommunicationFlsReport", call: reportsGetLastCommunicationFlsReport },
} satisfies EntityOperations;

/** /api/v1/reports/last-communication-lt */
export const reportsLastCommunicationLtOps = {
  entity: { endpoint: "reports/last-communication-lt", apiVersion: "v1" },
  page: { id: "reportsGetLastCommunicationLocationTracker", call: reportsGetLastCommunicationLocationTracker },
} satisfies EntityOperations;

/** /api/v1/reports/run */
export const reportsRunOps = {
  entity: { endpoint: "reports/run", apiVersion: "v1" },
  detail: { id: "reportsRunTaskListReport", call: reportsRunTaskListReport, param: "id" },
} satisfies EntityOperations;

/** /api/v1/reports/transactions-daily-count */
export const reportsTransactionsDailyCountOps = {
  entity: { endpoint: "reports/transactions-daily-count", apiVersion: "v1" },
  page: { id: "reportsGetTransactionsDailyCountReport", call: reportsGetTransactionsDailyCountReport },
} satisfies EntityOperations;

/** /api/v1/roles */
export const rolesOps = {
  entity: { endpoint: "roles", apiVersion: "v1" },
  page: { id: "rolesGetAll", call: rolesGetAll },
} satisfies EntityOperations;

/** /api/v1/server-info */
export const serverInfoOps = {
  entity: { endpoint: "server-info", apiVersion: "v1" },
  page: { id: "serverInfoGetConfig", call: serverInfoGetConfig },
} satisfies EntityOperations;

/** /api/v1/server-info/export-settings */
export const serverInfoExportSettingsOps = {
  entity: { endpoint: "server-info/export-settings", apiVersion: "v1" },
  page: { id: "serverInfoGetExportSettings", call: serverInfoGetExportSettings },
} satisfies EntityOperations;

/** /api/v1/service-app-events */
export const serviceAppEventsOps = {
  entity: { endpoint: "service-app-events", apiVersion: "v1" },
  page: { id: "serviceAppEventsGetEntityPage", call: serviceAppEventsGetEntityPage },
  create: { id: "serviceAppEventsCreateEntity", call: serviceAppEventsCreateEntity },
  detail: { id: "serviceAppEventsGetEntity", call: serviceAppEventsGetEntity, param: "id" },
  export: {
    id: "serviceAppEventsExportServiceAppEvents",
    call: serviceAppEventsExportServiceAppEvents,
    param: "format",
  },
} satisfies EntityOperations;

/** /api/v1/service-calls */
export const serviceCallsOps = {
  entity: { endpoint: "service-calls", apiVersion: "v1" },
  page: { id: "serviceCallsGetServiceCallsPage", call: serviceCallsGetServiceCallsPage },
  list: { id: "serviceCallsListServiceCalls", call: serviceCallsListServiceCalls },
  export: { id: "serviceCallsExportServiceCalls", call: serviceCallsExportServiceCalls, param: "format" },
} satisfies EntityOperations;

/** /api/v1/service-calls/list */
export const serviceCallsListOps = {
  entity: { endpoint: "service-calls/list", apiVersion: "v1" },
  page: { id: "serviceCallsListServiceCalls", call: serviceCallsListServiceCalls },
} satisfies EntityOperations;

/** /api/v1/service-dashboard */
export const serviceDashboardOps = {
  entity: { endpoint: "service-dashboard", apiVersion: "v1" },
  page: { id: "serviceDashboardGetDashboardData", call: serviceDashboardGetDashboardData },
} satisfies EntityOperations;

/** /api/v1/service-task */
export const serviceTaskOps = {
  entity: { endpoint: "service-task", apiVersion: "v1" },
  page: { id: "serviceTaskGetServiceTaskPage", call: serviceTaskGetServiceTaskPage },
  create: { id: "serviceTaskCreateServiceTask", call: serviceTaskCreateServiceTask },
  detail: { id: "serviceTaskGetServiceTask", call: serviceTaskGetServiceTask, param: "id" },
  update: { id: "serviceTaskUpdateServiceTask", call: serviceTaskUpdateServiceTask, param: "id" },
  list: { id: "serviceTaskGetServiceTaskList", call: serviceTaskGetServiceTaskList },
  export: { id: "serviceTaskExportList", call: serviceTaskExportList, param: "format" },
  logs: { id: "serviceTaskGetServiceTaskLogsPage", call: serviceTaskGetServiceTaskLogsPage, param: "id" },
} satisfies EntityOperations;

/** /api/v1/service-task-categories */
export const serviceTaskCategoriesOps = {
  entity: { endpoint: "service-task-categories", apiVersion: "v1" },
  page: { id: "serviceTaskCategoriesGetEntityPage", call: serviceTaskCategoriesGetEntityPage },
  create: { id: "serviceTaskCategoriesCreateEntity", call: serviceTaskCategoriesCreateEntity },
  detail: { id: "serviceTaskCategoriesGetEntity", call: serviceTaskCategoriesGetEntity, param: "id" },
  update: { id: "serviceTaskCategoriesUpdateEntity", call: serviceTaskCategoriesUpdateEntity, param: "id" },
  remove: { id: "serviceTaskCategoriesDeleteEntity", call: serviceTaskCategoriesDeleteEntity, param: "id" },
  list: { id: "serviceTaskCategoriesListCategories", call: serviceTaskCategoriesListCategories },
  valueUsed: { id: "serviceTaskCategoriesIsValueUsed", call: serviceTaskCategoriesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/service-task-categories/list */
export const serviceTaskCategoriesListOps = {
  entity: { endpoint: "service-task-categories/list", apiVersion: "v1" },
  page: { id: "serviceTaskCategoriesListCategories", call: serviceTaskCategoriesListCategories },
} satisfies EntityOperations;

/** /api/v1/service-task-categories/value-used */
export const serviceTaskCategoriesValueUsedOps = {
  entity: { endpoint: "service-task-categories/value-used", apiVersion: "v1" },
  create: { id: "serviceTaskCategoriesIsValueUsed", call: serviceTaskCategoriesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/service-task-causes */
export const serviceTaskCausesOps = {
  entity: { endpoint: "service-task-causes", apiVersion: "v1" },
  page: { id: "serviceTaskCausesGetEntityPage", call: serviceTaskCausesGetEntityPage },
  create: { id: "serviceTaskCausesCreateEntity", call: serviceTaskCausesCreateEntity },
  detail: { id: "serviceTaskCausesGetEntity", call: serviceTaskCausesGetEntity, param: "id" },
  update: { id: "serviceTaskCausesUpdateEntity", call: serviceTaskCausesUpdateEntity, param: "id" },
  remove: { id: "serviceTaskCausesDeleteEntity", call: serviceTaskCausesDeleteEntity, param: "id" },
  list: { id: "serviceTaskCausesListCauses", call: serviceTaskCausesListCauses },
  valueUsed: { id: "serviceTaskCausesIsValueUsed", call: serviceTaskCausesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/service-task-causes/list */
export const serviceTaskCausesListOps = {
  entity: { endpoint: "service-task-causes/list", apiVersion: "v1" },
  page: { id: "serviceTaskCausesListCauses", call: serviceTaskCausesListCauses },
} satisfies EntityOperations;

/** /api/v1/service-task-causes/value-used */
export const serviceTaskCausesValueUsedOps = {
  entity: { endpoint: "service-task-causes/value-used", apiVersion: "v1" },
  create: { id: "serviceTaskCausesIsValueUsed", call: serviceTaskCausesIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/service-task-solutions */
export const serviceTaskSolutionsOps = {
  entity: { endpoint: "service-task-solutions", apiVersion: "v1" },
  page: { id: "serviceTaskSolutionsGetEntityPage", call: serviceTaskSolutionsGetEntityPage },
  create: { id: "serviceTaskSolutionsCreateEntity", call: serviceTaskSolutionsCreateEntity },
  detail: { id: "serviceTaskSolutionsGetEntity", call: serviceTaskSolutionsGetEntity, param: "id" },
  update: { id: "serviceTaskSolutionsUpdateEntity", call: serviceTaskSolutionsUpdateEntity, param: "id" },
  remove: { id: "serviceTaskSolutionsDeleteEntity", call: serviceTaskSolutionsDeleteEntity, param: "id" },
  list: { id: "serviceTaskSolutionsListSolutions", call: serviceTaskSolutionsListSolutions },
  valueUsed: { id: "serviceTaskSolutionsIsValueUsed", call: serviceTaskSolutionsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/service-task-solutions/list */
export const serviceTaskSolutionsListOps = {
  entity: { endpoint: "service-task-solutions/list", apiVersion: "v1" },
  page: { id: "serviceTaskSolutionsListSolutions", call: serviceTaskSolutionsListSolutions },
} satisfies EntityOperations;

/** /api/v1/service-task-solutions/value-used */
export const serviceTaskSolutionsValueUsedOps = {
  entity: { endpoint: "service-task-solutions/value-used", apiVersion: "v1" },
  create: { id: "serviceTaskSolutionsIsValueUsed", call: serviceTaskSolutionsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/service-task/list */
export const serviceTaskListOps = {
  entity: { endpoint: "service-task/list", apiVersion: "v1" },
  page: { id: "serviceTaskGetServiceTaskList", call: serviceTaskGetServiceTaskList },
} satisfies EntityOperations;

/** /api/v1/sim-cards/terminate */
export const simCardsTerminateOps = {
  entity: { endpoint: "sim-cards/terminate", apiVersion: "v1" },
  create: { id: "simCardsTerminateSimCards", call: simCardsTerminateSimCards },
} satisfies EntityOperations;

/** /api/v1/sim-cards/terminate/terminate-sim-template.csv */
export const simCardsTerminateTerminateSimTemplateCsvOps = {
  entity: { endpoint: "sim-cards/terminate/terminate-sim-template.csv", apiVersion: "v1" },
  page: { id: "simCardsGetTerminateTemplate", call: simCardsGetTerminateTemplate },
} satisfies EntityOperations;

/** /api/v1/sim-cards/terminate/validate */
export const simCardsTerminateValidateOps = {
  entity: { endpoint: "sim-cards/terminate/validate", apiVersion: "v1" },
  create: { id: "simCardsValidatSimCardsForTermination", call: simCardsValidatSimCardsForTermination },
} satisfies EntityOperations;

/** /api/v1/sloc/customer-name */
export const slocCustomerNameOps = {
  entity: { endpoint: "sloc/customer-name", apiVersion: "v1" },
  detail: { id: "slocGetSlocCustomerName", call: slocGetSlocCustomerName, param: "customerId" },
} satisfies EntityOperations;

/** /api/v1/sloc/emptying-options */
export const slocEmptyingOptionsOps = {
  entity: { endpoint: "sloc/emptying-options", apiVersion: "v1" },
  detail: { id: "slocGetSlocEmptyingOptions", call: slocGetSlocEmptyingOptions, param: "customerId" },
} satisfies EntityOperations;

/** /api/v1/sloc/groups */
export const slocGroupsOps = {
  entity: { endpoint: "sloc/groups", apiVersion: "v1" },
  detail: { id: "slocGetSlocGroups", call: slocGetSlocGroups, param: "customerId" },
} satisfies EntityOperations;

/** /api/v1/sloc/groups/api-key */
export const slocGroupsApiKeyOps = {
  entity: { endpoint: "sloc/groups/api-key", apiVersion: "v1" },
  create: { id: "slocGetSlocGroupsByApiKey", call: slocGetSlocGroupsByApiKey },
} satisfies EntityOperations;

/** /api/v1/sloc/has-valid-key */
export const slocHasValidKeyOps = {
  entity: { endpoint: "sloc/has-valid-key", apiVersion: "v1" },
  detail: { id: "slocHasValidSlocApiKey", call: slocHasValidSlocApiKey, param: "customerId" },
} satisfies EntityOperations;

/** /api/v1/sloc/profiles */
export const slocProfilesOps = {
  entity: { endpoint: "sloc/profiles", apiVersion: "v1" },
  detail: { id: "slocGetSlocProfiles", call: slocGetSlocProfiles, param: "customerId" },
} satisfies EntityOperations;

/** /api/v1/sloc/receive-data */
export const slocReceiveDataOps = {
  entity: { endpoint: "sloc/receive-data", apiVersion: "v1" },
  create: { id: "slocReceiveSlocData", call: slocReceiveSlocData },
} satisfies EntityOperations;

/** /api/v1/social-service-actions */
export const socialServiceActionsOps = {
  entity: { endpoint: "social-service-actions", apiVersion: "v1" },
  page: { id: "socialServiceActionsGetEntityPage", call: socialServiceActionsGetEntityPage },
  detail: { id: "socialServiceActionsGetEntity", call: socialServiceActionsGetEntity, param: "id" },
  update: { id: "socialServiceActionsUpdateEntity", call: socialServiceActionsUpdateEntity, param: "id" },
  list: { id: "socialServiceActionsListCategories", call: socialServiceActionsListCategories },
} satisfies EntityOperations;

/** /api/v1/social-service-actions/list */
export const socialServiceActionsListOps = {
  entity: { endpoint: "social-service-actions/list", apiVersion: "v1" },
  page: { id: "socialServiceActionsListCategories", call: socialServiceActionsListCategories },
} satisfies EntityOperations;

/** /api/v1/social-service-notifications/tasks */
export const socialServiceNotificationsTasksOps = {
  entity: { endpoint: "social-service-notifications/tasks", apiVersion: "v1" },
  create: { id: "socialServiceNotificationsNotifyRunners", call: socialServiceNotificationsNotifyRunners },
} satisfies EntityOperations;

/** /api/v1/social-service-runners */
export const socialServiceRunnersOps = {
  entity: { endpoint: "social-service-runners", apiVersion: "v1" },
  page: { id: "socialServiceRunnersGetEntityPage", call: socialServiceRunnersGetEntityPage },
  list: { id: "socialServiceRunnersListUsers", call: socialServiceRunnersListUsers },
} satisfies EntityOperations;

/** /api/v1/social-service-runners/list */
export const socialServiceRunnersListOps = {
  entity: { endpoint: "social-service-runners/list", apiVersion: "v1" },
  page: { id: "socialServiceRunnersListUsers", call: socialServiceRunnersListUsers },
} satisfies EntityOperations;

/** /api/v1/social-service-task */
export const socialServiceTaskOps = {
  entity: { endpoint: "social-service-task", apiVersion: "v1" },
  page: { id: "socialServiceTaskGetEntityPage", call: socialServiceTaskGetEntityPage },
  detail: { id: "socialServiceTaskGetSocialServiceTask", call: socialServiceTaskGetSocialServiceTask, param: "id" },
} satisfies EntityOperations;

/** /api/v1/social-service-task/list/my */
export const socialServiceTaskListMyOps = {
  entity: { endpoint: "social-service-task/list/my", apiVersion: "v1" },
  page: {
    id: "socialServiceTaskListOfAssignedSocialServiceTasksToCurrentUser",
    call: socialServiceTaskListOfAssignedSocialServiceTasksToCurrentUser,
  },
} satisfies EntityOperations;

/** /api/v1/social-service-task/map */
export const socialServiceTaskMapOps = {
  entity: { endpoint: "social-service-task/map", apiVersion: "v1" },
  page: { id: "socialServiceTaskSocialServiceTasksMap", call: socialServiceTaskSocialServiceTasksMap },
} satisfies EntityOperations;

/** /api/v1/social-service/notification-settings */
export const socialServiceNotificationSettingsOps = {
  entity: { endpoint: "social-service/notification-settings", apiVersion: "v1" },
  page: { id: "socialServiceGetRunnerNotificationSettings", call: socialServiceGetRunnerNotificationSettings },
} satisfies EntityOperations;

/** /api/v1/social-service/transactions */
export const socialServiceTransactionsOps = {
  entity: { endpoint: "social-service/transactions", apiVersion: "v1" },
  page: { id: "socialServiceGetTransactions", call: socialServiceGetTransactions },
} satisfies EntityOperations;

/** /api/v1/superset-dashboards */
export const supersetDashboardsOps = {
  entity: { endpoint: "superset-dashboards", apiVersion: "v1" },
  page: { id: "supersetDashboardsGetEntityPage", call: supersetDashboardsGetEntityPage },
  create: { id: "supersetDashboardsCreateEntity", call: supersetDashboardsCreateEntity },
  detail: { id: "supersetDashboardsGetEntity", call: supersetDashboardsGetEntity, param: "id" },
  update: { id: "supersetDashboardsUpdateEntity", call: supersetDashboardsUpdateEntity, param: "id" },
  remove: { id: "supersetDashboardsDeleteEntity", call: supersetDashboardsDeleteEntity, param: "id" },
  list: { id: "supersetDashboardsListEntities", call: supersetDashboardsListEntities },
  valueUsed: { id: "supersetDashboardsIsValueUsed", call: supersetDashboardsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/superset-dashboards/list */
export const supersetDashboardsListOps = {
  entity: { endpoint: "superset-dashboards/list", apiVersion: "v1" },
  page: { id: "supersetDashboardsListEntities", call: supersetDashboardsListEntities },
} satisfies EntityOperations;

/** /api/v1/superset-dashboards/value-used */
export const supersetDashboardsValueUsedOps = {
  entity: { endpoint: "superset-dashboards/value-used", apiVersion: "v1" },
  create: { id: "supersetDashboardsIsValueUsed", call: supersetDashboardsIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/system-operations-log */
export const systemOperationsLogOps = {
  entity: { endpoint: "system-operations-log", apiVersion: "v1" },
  page: { id: "systemOperationsLogGetEntityPage", call: systemOperationsLogGetEntityPage },
  detail: { id: "systemOperationsLogGetIssue", call: systemOperationsLogGetIssue, param: "id" },
  export: { id: "systemOperationsLogExportList", call: systemOperationsLogExportList, param: "format" },
} satisfies EntityOperations;

/** /api/v1/technicians */
export const techniciansOps = {
  entity: { endpoint: "technicians", apiVersion: "v1" },
  page: { id: "techniciansGetEntityPage", call: techniciansGetEntityPage },
  list: { id: "techniciansListUsers", call: techniciansListUsers },
} satisfies EntityOperations;

/** /api/v1/technicians/list */
export const techniciansListOps = {
  entity: { endpoint: "technicians/list", apiVersion: "v1" },
  page: { id: "techniciansListUsers", call: techniciansListUsers },
} satisfies EntityOperations;

/** /api/v1/truck-bodies */
export const truckBodiesOps = {
  entity: { endpoint: "truck-bodies", apiVersion: "v1" },
  page: { id: "truckBodiesGetEntityPage", call: truckBodiesGetEntityPage },
  create: { id: "truckBodiesCreateEntity", call: truckBodiesCreateEntity },
  detail: { id: "truckBodiesGetEntity", call: truckBodiesGetEntity, param: "id" },
  update: { id: "truckBodiesUpdateEntity", call: truckBodiesUpdateEntity, param: "id" },
  remove: { id: "truckBodiesDeleteEntity", call: truckBodiesDeleteEntity, param: "id" },
  list: { id: "truckBodiesListEntities", call: truckBodiesListEntities },
} satisfies EntityOperations;

/** /api/v1/truck-bodies/list */
export const truckBodiesListOps = {
  entity: { endpoint: "truck-bodies/list", apiVersion: "v1" },
  page: { id: "truckBodiesListEntities", call: truckBodiesListEntities },
} satisfies EntityOperations;

/** /api/v1/truck-depots */
export const truckDepotsOps = {
  entity: { endpoint: "truck-depots", apiVersion: "v1" },
  page: { id: "truckDepotsGetEntityPage", call: truckDepotsGetEntityPage },
  create: { id: "truckDepotsCreateEntity", call: truckDepotsCreateEntity },
  detail: { id: "truckDepotsGetEntity", call: truckDepotsGetEntity, param: "id" },
  update: { id: "truckDepotsUpdateEntity", call: truckDepotsUpdateEntity, param: "id" },
  remove: { id: "truckDepotsDeleteEntity", call: truckDepotsDeleteEntity, param: "id" },
  list: { id: "truckDepotsListEntities", call: truckDepotsListEntities },
  trucksPartial: { id: "truckDepotsUpdateContainersGroup", call: truckDepotsUpdateContainersGroup, param: "id" },
} satisfies EntityOperations;

/** /api/v1/truck-depots/list */
export const truckDepotsListOps = {
  entity: { endpoint: "truck-depots/list", apiVersion: "v1" },
  page: { id: "truckDepotsListEntities", call: truckDepotsListEntities },
} satisfies EntityOperations;

/** /api/v1/truck-types */
export const truckTypesOps = {
  entity: { endpoint: "truck-types", apiVersion: "v1" },
  page: { id: "truckTypesGetEntityPage", call: truckTypesGetEntityPage },
  create: { id: "truckTypesCreateEntity", call: truckTypesCreateEntity },
  detail: { id: "truckTypesGetEntity", call: truckTypesGetEntity, param: "id" },
  update: { id: "truckTypesUpdateEntity", call: truckTypesUpdateEntity, param: "id" },
  remove: { id: "truckTypesDeleteEntity", call: truckTypesDeleteEntity, param: "id" },
  list: { id: "truckTypesListEntities", call: truckTypesListEntities },
} satisfies EntityOperations;

/** /api/v1/truck-types/list */
export const truckTypesListOps = {
  entity: { endpoint: "truck-types/list", apiVersion: "v1" },
  page: { id: "truckTypesListEntities", call: truckTypesListEntities },
} satisfies EntityOperations;

/** /api/v1/trucks */
export const trucksOps = {
  entity: { endpoint: "trucks", apiVersion: "v1" },
  page: { id: "trucksGetEntityPage", call: trucksGetEntityPage },
  create: { id: "trucksCreateEntity", call: trucksCreateEntity },
  detail: { id: "trucksGetEntity", call: trucksGetEntity, param: "id" },
  update: { id: "trucksUpdateEntity", call: trucksUpdateEntity, param: "id" },
  remove: { id: "trucksDeleteEntity", call: trucksDeleteEntity, param: "id" },
  list: { id: "trucksListEntities", call: trucksListEntities },
} satisfies EntityOperations;

/** /api/v1/trucks/list */
export const trucksListOps = {
  entity: { endpoint: "trucks/list", apiVersion: "v1" },
  page: { id: "trucksListEntities", call: trucksListEntities },
} satisfies EntityOperations;

/** /api/v1/user-notification-settings */
export const userNotificationSettingsOps = {
  entity: { endpoint: "user-notification-settings", apiVersion: "v1" },
  page: {
    id: "userNotificationSettingsGetUserNotificationSettingsPage",
    call: userNotificationSettingsGetUserNotificationSettingsPage,
  },
  create: {
    id: "userNotificationSettingsCreateProfileNotificationSetting",
    call: userNotificationSettingsCreateProfileNotificationSetting,
  },
  detail: {
    id: "userNotificationSettingsGetProfileNotificationSetting",
    call: userNotificationSettingsGetProfileNotificationSetting,
    param: "id",
  },
  update: {
    id: "userNotificationSettingsUpdateProfileNotificationSetting",
    call: userNotificationSettingsUpdateProfileNotificationSetting,
    param: "id",
  },
  remove: {
    id: "userNotificationSettingsDeleteNotificationSetting",
    call: userNotificationSettingsDeleteNotificationSetting,
    param: "id",
  },
} satisfies EntityOperations;

/** /api/v1/user-wizard */
export const userWizardOps = {
  entity: { endpoint: "user-wizard", apiVersion: "v1" },
  page: { id: "userWizardGetUserWizardPage", call: userWizardGetUserWizardPage },
  create: { id: "userWizardCreateUserWizard", call: userWizardCreateUserWizard },
  detail: { id: "userWizardGetUserWizard", call: userWizardGetUserWizard, param: "id" },
  update: { id: "userWizardUpdateUserWizard", call: userWizardUpdateUserWizard, param: "id" },
  remove: { id: "userWizardDeleteUserWizard", call: userWizardDeleteUserWizard, param: "id" },
} satisfies EntityOperations;

/** /api/v1/users */
export const usersOps = {
  entity: { endpoint: "users", apiVersion: "v1" },
  page: { id: "usersGetEntityPage", call: usersGetEntityPage },
  create: { id: "usersCreateEntity", call: usersCreateEntity },
  detail: { id: "usersGetEntity", call: usersGetEntity, param: "id" },
  update: { id: "usersUpdateEntity", call: usersUpdateEntity, param: "id" },
  remove: { id: "usersDeleteEntity", call: usersDeleteEntity, param: "id" },
  activate: { id: "usersActivateUser", call: usersActivateUser, param: "id" },
  list: { id: "usersListUsers", call: usersListUsers },
  export: { id: "usersExportList", call: usersExportList, param: "format" },
  valueUsed: { id: "usersIsValueUsed", call: usersIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/users/devices */
export const usersDevicesOps = {
  entity: { endpoint: "users/devices", apiVersion: "v1" },
  remove: { id: "usersUnregisterOwnDevice", call: usersUnregisterOwnDevice, param: "deviceId" },
} satisfies EntityOperations;

/** /api/v1/users/favourites */
export const usersFavouritesOps = {
  entity: { endpoint: "users/favourites", apiVersion: "v1" },
  page: { id: "usersGetMyFavourites", call: usersGetMyFavourites },
} satisfies EntityOperations;

/** /api/v1/users/list */
export const usersListOps = {
  entity: { endpoint: "users/list", apiVersion: "v1" },
  page: { id: "usersListUsers", call: usersListUsers },
} satisfies EntityOperations;

/** /api/v1/users/password */
export const usersPasswordOps = {
  entity: { endpoint: "users/password", apiVersion: "v1" },
  create: { id: "usersChangeOwnPassword", call: usersChangeOwnPassword },
} satisfies EntityOperations;

/** /api/v1/users/password-reset */
export const usersPasswordResetOps = {
  entity: { endpoint: "users/password-reset", apiVersion: "v1" },
  create: { id: "usersInitPasswordReset", call: usersInitPasswordReset },
  detail: { id: "usersVerifyPasswordReset", call: usersVerifyPasswordReset, param: "token" },
} satisfies EntityOperations;

/** /api/v1/users/preferences */
export const usersPreferencesOps = {
  entity: { endpoint: "users/preferences", apiVersion: "v1" },
  page: { id: "usersGetMyPreferences", call: usersGetMyPreferences },
} satisfies EntityOperations;

/** /api/v1/users/profile */
export const usersProfileOps = {
  entity: { endpoint: "users/profile", apiVersion: "v1" },
  page: { id: "usersGetProfile", call: usersGetProfile },
  update: { id: "usersUpdateProfile", call: usersUpdateProfile, param: "id" },
} satisfies EntityOperations;

/** /api/v1/users/totp-reset */
export const usersTotpResetOps = {
  entity: { endpoint: "users/totp-reset", apiVersion: "v1" },
  create: { id: "usersResetTotpSettings", call: usersResetTotpSettings },
} satisfies EntityOperations;

/** /api/v1/users/value-used */
export const usersValueUsedOps = {
  entity: { endpoint: "users/value-used", apiVersion: "v1" },
  create: { id: "usersIsValueUsed", call: usersIsValueUsed },
} satisfies EntityOperations;

/** /api/v1/waste-categories */
export const wasteCategoriesOps = {
  entity: { endpoint: "waste-categories", apiVersion: "v1" },
  page: { id: "wasteCategoriesListContainerLockTypes", call: wasteCategoriesListContainerLockTypes },
} satisfies EntityOperations;

/** /api/v1/waste-yards */
export const wasteYardsOps = {
  entity: { endpoint: "waste-yards", apiVersion: "v1" },
  page: { id: "wasteYardsGetEntityPage", call: wasteYardsGetEntityPage },
  create: { id: "wasteYardsCreateEntity", call: wasteYardsCreateEntity },
  detail: { id: "wasteYardsGetEntity", call: wasteYardsGetEntity, param: "id" },
  update: { id: "wasteYardsUpdateEntity", call: wasteYardsUpdateEntity, param: "id" },
  remove: { id: "wasteYardsDeleteEntity", call: wasteYardsDeleteEntity, param: "id" },
  list: { id: "wasteYardsListEntities", call: wasteYardsListEntities },
} satisfies EntityOperations;

/** /api/v1/waste-yards/list */
export const wasteYardsListOps = {
  entity: { endpoint: "waste-yards/list", apiVersion: "v1" },
  page: { id: "wasteYardsListEntities", call: wasteYardsListEntities },
} satisfies EntityOperations;

/** /api/v2/authorize */
export const authorizeV2Ops = {
  entity: { endpoint: "authorize", apiVersion: "v2" },
  create: { id: "authorizeAuthorizeDeviceV2", call: authorizeAuthorizeDeviceV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/api */
export const authorizeApiV2Ops = {
  entity: { endpoint: "authorize/api", apiVersion: "v2" },
  create: { id: "authorizeAuthorizeApiV2", call: authorizeAuthorizeApiV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/apple */
export const authorizeAppleV2Ops = {
  entity: { endpoint: "authorize/apple", apiVersion: "v2" },
  create: { id: "authorizeLoginAppleV2", call: authorizeLoginAppleV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/apple/link */
export const authorizeAppleLinkV2Ops = {
  entity: { endpoint: "authorize/apple/link", apiVersion: "v2" },
  create: { id: "authorizeLinkAppleCredentialsV2", call: authorizeLinkAppleCredentialsV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/contract/check */
export const authorizeContractCheckV2Ops = {
  entity: { endpoint: "authorize/contract/check", apiVersion: "v2" },
  create: { id: "authorizeCheckContractV2", call: authorizeCheckContractV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/google */
export const authorizeGoogleV2Ops = {
  entity: { endpoint: "authorize/google", apiVersion: "v2" },
  create: { id: "authorizeLoginGoogleV2", call: authorizeLoginGoogleV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/google/link */
export const authorizeGoogleLinkV2Ops = {
  entity: { endpoint: "authorize/google/link", apiVersion: "v2" },
  create: { id: "authorizeLinkGoogleCredentialsV2", call: authorizeLinkGoogleCredentialsV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/link */
export const authorizeLinkV2Ops = {
  entity: { endpoint: "authorize/link", apiVersion: "v2" },
  create: { id: "authorizeLinkCredentialsV2", call: authorizeLinkCredentialsV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/link-device */
export const authorizeLinkDeviceV2Ops = {
  entity: { endpoint: "authorize/link-device", apiVersion: "v2" },
  create: { id: "authorizeAuthorizeDeviceFromApiV2", call: authorizeAuthorizeDeviceFromApiV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/login */
export const authorizeLoginV2Ops = {
  entity: { endpoint: "authorize/login", apiVersion: "v2" },
  page: { id: "authorizeLoginCookieVerifyV2", call: authorizeLoginCookieVerifyV2 },
  create: { id: "authorizeLoginCookieV2", call: authorizeLoginCookieV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/login/totp */
export const authorizeLoginTotpV2Ops = {
  entity: { endpoint: "authorize/login/totp", apiVersion: "v2" },
  create: { id: "authorizeVerifyLoginWithTotpV2", call: authorizeVerifyLoginWithTotpV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/login/totp-backup */
export const authorizeLoginTotpBackupV2Ops = {
  entity: { endpoint: "authorize/login/totp-backup", apiVersion: "v2" },
  create: { id: "authorizeVerifyLoginWithTotpBackupCodeV2", call: authorizeVerifyLoginWithTotpBackupCodeV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/logout */
export const authorizeLogoutV2Ops = {
  entity: { endpoint: "authorize/logout", apiVersion: "v2" },
  page: { id: "authorizeLogoutV2", call: authorizeLogoutV2 },
  create: { id: "authorizeLogoutPostV2", call: authorizeLogoutPostV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/refresh-token */
export const authorizeRefreshTokenV2Ops = {
  entity: { endpoint: "authorize/refresh-token", apiVersion: "v2" },
  create: { id: "authorizeAuthorizeRefreshTokenV2", call: authorizeAuthorizeRefreshTokenV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/register */
export const authorizeRegisterV2Ops = {
  entity: { endpoint: "authorize/register", apiVersion: "v2" },
  create: { id: "authorizeRegisterDeviceV2", call: authorizeRegisterDeviceV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/register-social-service */
export const authorizeRegisterSocialServiceV2Ops = {
  entity: { endpoint: "authorize/register-social-service", apiVersion: "v2" },
  create: { id: "authorizeRegisterServiceRunnerV2", call: authorizeRegisterServiceRunnerV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/reregister */
export const authorizeReregisterV2Ops = {
  entity: { endpoint: "authorize/reregister", apiVersion: "v2" },
  create: { id: "authorizeReRegisterUserV2", call: authorizeReRegisterUserV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/service-app */
export const authorizeServiceAppV2Ops = {
  entity: { endpoint: "authorize/service-app", apiVersion: "v2" },
  create: { id: "authorizeAuthorizeServiceDeviceV2", call: authorizeAuthorizeServiceDeviceV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/totp/finalize */
export const authorizeTotpFinalizeV2Ops = {
  entity: { endpoint: "authorize/totp/finalize", apiVersion: "v2" },
  create: { id: "authorizeFinalizeTotpV2", call: authorizeFinalizeTotpV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/totp/setup */
export const authorizeTotpSetupV2Ops = {
  entity: { endpoint: "authorize/totp/setup", apiVersion: "v2" },
  page: { id: "authorizeSetupTotpV2", call: authorizeSetupTotpV2 },
} satisfies EntityOperations;

/** /api/v2/authorize/unlink */
export const authorizeUnlinkV2Ops = {
  entity: { endpoint: "authorize/unlink", apiVersion: "v2" },
  create: { id: "authorizeUnlinkCredentialsV2", call: authorizeUnlinkCredentialsV2 },
} satisfies EntityOperations;

/** /api/v2/container-configuration-templates */
export const containerConfigurationTemplatesV2Ops = {
  entity: { endpoint: "container-configuration-templates", apiVersion: "v2" },
  page: { id: "containerConfigurationTemplatesGetEntityPageV2", call: containerConfigurationTemplatesGetEntityPageV2 },
  create: { id: "containerConfigurationTemplatesCreateEntityV2", call: containerConfigurationTemplatesCreateEntityV2 },
  detail: {
    id: "containerConfigurationTemplatesGetEntityV2",
    call: containerConfigurationTemplatesGetEntityV2,
    param: "id",
  },
  update: {
    id: "containerConfigurationTemplatesUpdateEntityV2",
    call: containerConfigurationTemplatesUpdateEntityV2,
    param: "id",
  },
  remove: {
    id: "containerConfigurationTemplatesDeleteEntityV2",
    call: containerConfigurationTemplatesDeleteEntityV2,
    param: "id",
  },
  valueUsed: { id: "containerConfigurationTemplatesIsValueUsedV2", call: containerConfigurationTemplatesIsValueUsedV2 },
} satisfies EntityOperations;

/** /api/v2/container-configuration-templates/value-used */
export const containerConfigurationTemplatesValueUsedV2Ops = {
  entity: { endpoint: "container-configuration-templates/value-used", apiVersion: "v2" },
  create: { id: "containerConfigurationTemplatesIsValueUsedV2", call: containerConfigurationTemplatesIsValueUsedV2 },
} satisfies EntityOperations;

/** /api/v2/containers */
export const containersV2Ops = {
  entity: { endpoint: "containers", apiVersion: "v2" },
  page: { id: "containersGetEntityPageV2", call: containersGetEntityPageV2 },
  create: { id: "containersCreateEntityV2", call: containersCreateEntityV2 },
  update: { id: "containersUpdateEntityV2", call: containersUpdateEntityV2, param: "id" },
  export: { id: "containersExportListV2", call: containersExportListV2, param: "format" },
} satisfies EntityOperations;

/** /api/v2/containers/list-paged */
export const containersListPagedV2Ops = {
  entity: { endpoint: "containers/list-paged", apiVersion: "v2" },
  page: { id: "containersGetInfoEntityPageV2", call: containersGetInfoEntityPageV2 },
} satisfies EntityOperations;

/** /api/v2/containers/map */
export const containersMapV2Ops = {
  entity: { endpoint: "containers/map", apiVersion: "v2" },
  page: { id: "containersGetContainerMapV2", call: containersGetContainerMapV2 },
} satisfies EntityOperations;

/** /api/v2/customers */
export const customersV2Ops = {
  entity: { endpoint: "customers", apiVersion: "v2" },
  page: { id: "customersGetEntityPageV2", call: customersGetEntityPageV2 },
  create: { id: "customersCreateEntityV2", call: customersCreateEntityV2 },
  detail: { id: "customersGetEntityV2", call: customersGetEntityV2, param: "id" },
  update: { id: "customersUpdateEntityV2", call: customersUpdateEntityV2, param: "id" },
  remove: { id: "customersDeleteEntityV2", call: customersDeleteEntityV2, param: "id" },
  activate: { id: "customersActivateEntityV2", call: customersActivateEntityV2, param: "id" },
  list: { id: "customersListEntitiesV2", call: customersListEntitiesV2 },
  export: { id: "customersExportListV2", call: customersExportListV2, param: "format" },
  valueUsed: { id: "customersIsValueUsedV2", call: customersIsValueUsedV2 },
} satisfies EntityOperations;

/** /api/v2/customers/departments */
export const customersDepartmentsV2Ops = {
  entity: { endpoint: "customers/departments", apiVersion: "v2" },
  list: { id: "customersListDepartmentsV2", call: customersListDepartmentsV2 },
} satisfies EntityOperations;

/** /api/v2/customers/departments/list */
export const customersDepartmentsListV2Ops = {
  entity: { endpoint: "customers/departments/list", apiVersion: "v2" },
  page: { id: "customersListDepartmentsV2", call: customersListDepartmentsV2 },
} satisfies EntityOperations;

/** /api/v2/customers/list */
export const customersListV2Ops = {
  entity: { endpoint: "customers/list", apiVersion: "v2" },
  page: { id: "customersListEntitiesV2", call: customersListEntitiesV2 },
} satisfies EntityOperations;

/** /api/v2/customers/pro-alpha-numbers */
export const customersProAlphaNumbersV2Ops = {
  entity: { endpoint: "customers/pro-alpha-numbers", apiVersion: "v2" },
  create: { id: "customersImportProAlphaNumbersV2", call: customersImportProAlphaNumbersV2 },
} satisfies EntityOperations;

/** /api/v2/customers/pro-alpha-numbers/validate */
export const customersProAlphaNumbersValidateV2Ops = {
  entity: { endpoint: "customers/pro-alpha-numbers/validate", apiVersion: "v2" },
  create: { id: "customersValidateProAlphaNumbersV2", call: customersValidateProAlphaNumbersV2 },
} satisfies EntityOperations;

/** /api/v2/customers/template/location-trackers.csv */
export const customersTemplateLocationTrackersCsvV2Ops = {
  entity: { endpoint: "customers/template/location-trackers.csv", apiVersion: "v2" },
  page: { id: "customersGetImportTemplateLocationTrackersV2", call: customersGetImportTemplateLocationTrackersV2 },
} satisfies EntityOperations;

/** /api/v2/customers/template/nfc-cards.csv */
export const customersTemplateNfcCardsCsvV2Ops = {
  entity: { endpoint: "customers/template/nfc-cards.csv", apiVersion: "v2" },
  page: { id: "customersGetImportTemplateNfcCardsV2", call: customersGetImportTemplateNfcCardsV2 },
} satisfies EntityOperations;

/** /api/v2/customers/value-used */
export const customersValueUsedV2Ops = {
  entity: { endpoint: "customers/value-used", apiVersion: "v2" },
  create: { id: "customersIsValueUsedV2", call: customersIsValueUsedV2 },
} satisfies EntityOperations;

/** /api/v2/fractions */
export const fractionsV2Ops = {
  entity: { endpoint: "fractions", apiVersion: "v2" },
  page: { id: "fractionsGetEntityPageV2", call: fractionsGetEntityPageV2 },
  create: { id: "fractionsCreateEntityV2", call: fractionsCreateEntityV2 },
  detail: { id: "fractionsGetEntityV2", call: fractionsGetEntityV2, param: "id" },
  update: { id: "fractionsUpdateEntityV2", call: fractionsUpdateEntityV2, param: "id" },
  remove: { id: "fractionsDeleteEntityV2", call: fractionsDeleteEntityV2, param: "id" },
  list: { id: "fractionsListEntitiesV2", call: fractionsListEntitiesV2 },
  valueUsed: { id: "fractionsIsValueUsedV2", call: fractionsIsValueUsedV2 },
  containersPartial: { id: "fractionsUpdateContainersGroupV2", call: fractionsUpdateContainersGroupV2, param: "id" },
} satisfies EntityOperations;

/** /api/v2/fractions/list */
export const fractionsListV2Ops = {
  entity: { endpoint: "fractions/list", apiVersion: "v2" },
  page: { id: "fractionsListEntitiesV2", call: fractionsListEntitiesV2 },
} satisfies EntityOperations;

/** /api/v2/fractions/value-used */
export const fractionsValueUsedV2Ops = {
  entity: { endpoint: "fractions/value-used", apiVersion: "v2" },
  create: { id: "fractionsIsValueUsedV2", call: fractionsIsValueUsedV2 },
} satisfies EntityOperations;

/** /api/v2/free-access/containers-hw */
export const freeAccessContainersHwV2Ops = {
  entity: { endpoint: "free-access/containers-hw", apiVersion: "v2" },
  detail: {
    id: "freeAccessGetContainerFreeAccessTokenForHardwareUnitV2",
    call: freeAccessGetContainerFreeAccessTokenForHardwareUnitV2,
    param: "hardwareUnitId",
  },
} satisfies EntityOperations;

/** /api/v2/me */
export const meV2Ops = {
  entity: { endpoint: "me", apiVersion: "v2" },
  page: { id: "meGetUserProfileV2", call: meGetUserProfileV2 },
} satisfies EntityOperations;

/** /api/v2/me/containers */
export const meContainersV2Ops = {
  entity: { endpoint: "me/containers", apiVersion: "v2" },
  page: { id: "meGetContainersV2", call: meGetContainersV2 },
} satisfies EntityOperations;

/** /api/v2/me/containers/proto */
export const meContainersProtoV2Ops = {
  entity: { endpoint: "me/containers/proto", apiVersion: "v2" },
  page: { id: "meGetAllContainersDataV2V2", call: meGetAllContainersDataV2V2 },
} satisfies EntityOperations;

/** /api/v2/me/contracts */
export const meContractsV2Ops = {
  entity: { endpoint: "me/contracts", apiVersion: "v2" },
  create: { id: "meAddContractV2", call: meAddContractV2 },
  update: { id: "meUpdateUserContractV2", call: meUpdateUserContractV2, param: "contractId" },
} satisfies EntityOperations;

/** /api/v2/me/devices */
export const meDevicesV2Ops = {
  entity: { endpoint: "me/devices", apiVersion: "v2" },
  update: { id: "meUpdateUserDeviceV2", call: meUpdateUserDeviceV2, param: "deviceId" },
} satisfies EntityOperations;

/** /api/v2/me/features */
export const meFeaturesV2Ops = {
  entity: { endpoint: "me/features", apiVersion: "v2" },
  page: { id: "meGetFeaturesV2", call: meGetFeaturesV2 },
} satisfies EntityOperations;

/** /api/v2/me/map */
export const meMapV2Ops = {
  entity: { endpoint: "me/map", apiVersion: "v2" },
  page: { id: "meGetContainerMapV2", call: meGetContainerMapV2 },
} satisfies EntityOperations;

/** /api/v2/me/messages */
export const meMessagesV2Ops = {
  entity: { endpoint: "me/messages", apiVersion: "v2" },
  page: { id: "meGetMessagesV2", call: meGetMessagesV2 },
} satisfies EntityOperations;

/** /api/v2/me/reports/transaction-fraction-totals */
export const meReportsTransactionFractionTotalsV2Ops = {
  entity: { endpoint: "me/reports/transaction-fraction-totals", apiVersion: "v2" },
  page: { id: "meGetUserTransactionTotalsByFractionV2", call: meGetUserTransactionTotalsByFractionV2 },
} satisfies EntityOperations;

/** /api/v2/me/reports/transaction-fraction-totals/detailed */
export const meReportsTransactionFractionTotalsDetailedV2Ops = {
  entity: { endpoint: "me/reports/transaction-fraction-totals/detailed", apiVersion: "v2" },
  page: { id: "meGetUserTransactionTotalsByFractionDetailedV2", call: meGetUserTransactionTotalsByFractionDetailedV2 },
} satisfies EntityOperations;

/** /api/v2/me/reports/transaction-fractions */
export const meReportsTransactionFractionsV2Ops = {
  entity: { endpoint: "me/reports/transaction-fractions", apiVersion: "v2" },
  page: { id: "meGetUserTransactionFractionV2", call: meGetUserTransactionFractionV2 },
} satisfies EntityOperations;

/** /api/v2/me/reports/transaction-source-totals */
export const meReportsTransactionSourceTotalsV2Ops = {
  entity: { endpoint: "me/reports/transaction-source-totals", apiVersion: "v2" },
  page: { id: "meGetUserTransactionTotalsBySourceV2", call: meGetUserTransactionTotalsBySourceV2 },
} satisfies EntityOperations;

/** /api/v2/me/reports/transaction-totals */
export const meReportsTransactionTotalsV2Ops = {
  entity: { endpoint: "me/reports/transaction-totals", apiVersion: "v2" },
  page: { id: "meGetUserTransactionTotalsV2", call: meGetUserTransactionTotalsV2 },
} satisfies EntityOperations;

/** /api/v2/me/reports/transaction-totals/detailed */
export const meReportsTransactionTotalsDetailedV2Ops = {
  entity: { endpoint: "me/reports/transaction-totals/detailed", apiVersion: "v2" },
  page: { id: "meGetUserTransactionTotalsDetailedV2", call: meGetUserTransactionTotalsDetailedV2 },
} satisfies EntityOperations;

/** /api/v2/me/reports/transactions-daily-count */
export const meReportsTransactionsDailyCountV2Ops = {
  entity: { endpoint: "me/reports/transactions-daily-count", apiVersion: "v2" },
  page: { id: "meGetTransactionsDailyCountReportV2", call: meGetTransactionsDailyCountReportV2 },
} satisfies EntityOperations;

/** /api/v2/me/transactions */
export const meTransactionsV2Ops = {
  entity: { endpoint: "me/transactions", apiVersion: "v2" },
  page: { id: "meGetTransactionsV2", call: meGetTransactionsV2 },
} satisfies EntityOperations;

/** /api/v3/containers/map */
export const containersMapV3Ops = {
  entity: { endpoint: "containers/map", apiVersion: "v3" },
  page: { id: "containersGetContainerMapV3", call: containersGetContainerMapV3 },
} satisfies EntityOperations;
